/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
import { api } from 'store/api/base';
export type PoaStatus = 'active' | 'archived' | 'cancelled' | 'draft' | 'revoked' | 'unset';

export type App1d1b2841_DocumentMutationCession_CreateInputInput = {
  _?: boolean | null | undefined;
};

export type App12d801b5_DocumentMutationNpSupplyAgreement_CreateInputInput = {
  _?: boolean | null | undefined;
};

export type App36c5da51_DocumentMutationNs_CreateInputInput = {
  _?: boolean | null | undefined;
};

export type App70e9b8a9_DocumentMutationNs_CreateInputInput = {
  _?: boolean | null | undefined;
};

export type App70e9b8a9_DocumentMutationNs_UpdateInputInput = {
  _?: boolean | null | undefined;
};

export type App5182dd71_ControlCard_Update_Input = {
  actualQuantity: string;
  actualShipmentDate: string;
};

export type App5182dd71_OperationalRequest_Create_Input = {
  agreement: string;
  comments?: string | null | undefined;
  deliveryBasis: string;
  goodsType: string;
  isCommentEnabled?: string | null | undefined;
  quantity: string;
  requestDate: string;
  shippingDate: string;
  supplyAddress: string;
};

export type App5182dd71_ShipmentRegistry_FiltersInput = {
  input?: string | null | undefined;
  statusIds?: Array<string> | null | undefined;
};

export type App5182dd71_ShipmentReport_Create_Input = {
  NPDocumentNumber?: string | null | undefined;
  agreement?: string | null | undefined;
  orgBuyer?: string | null | undefined;
  orgSupplier?: string | null | undefined;
  period?: string | null | undefined;
  quantity?: string | null | undefined;
};

export type App5182dd71_ShipmentTask_Update_Input = {
  buyerEmployeeId?: string | null | undefined;
  supplierEmployeeId?: string | null | undefined;
};

export type App5705572d_DocumentMutationNs_CreateInputInput = {
  _?: boolean | null | undefined;
};

export type Core_ApplicationTrait =
  | 'dealBased'
  | 'processable'
  | 'regular'
  | 'separateInterface';

export type Core_DocumentSignatureType = 'pcks7' | 'ses' | 'undefined' | 'xmldsig';

export type Core_DocumentsDisplayableType =
  | 'agreement_base'
  | 'agreement_pcks7'
  | 'agreement_ses'
  | 'agreement_signed'
  | 'base'
  | 'pcks7'
  | 'ses'
  | 'signed';

export type Core_EmployeeInvitationMutationNs_InviteUnregisteredEmployeeInputInput = {
  FirstName: string;
  INN: string;
  LastName: string;
  MiddleName?: string | null | undefined;
  SNILS: string;
  participantEmail: Array<string>;
};

export type Core_EmployeeInvitationStatus =
  | 'approved'
  | 'initiated'
  | 'invalid'
  | 'rejected'
  | 'sent';

export type Core_EmployeeInvitationType =
  | 'employee_participation_invite'
  | 'employee_participation_request'
  | 'organization_partnership';

export type Core_EmployeeRole = 'administrator' | 'employee';

export type Core_EmployeeStatus =
  | 'blocked'
  | 'cancelled'
  | 'invited'
  | 'new'
  | 'pending'
  | 'purged'
  | 'registered'
  | 'unset';

export type Core_EmployeeType = 'general' | 'outside' | 'temporal' | 'unset';

export type Core_OrganizationAttributeInput = {
  name: string;
  value: string;
};

export type Core_OrganizationEmployeeStatus =
  | 'blocked'
  | 'cancelled'
  | 'expired'
  | 'initiated'
  | 'invited'
  | 'pending'
  | 'unset'
  | 'valid';

/** Перечисление, описывающее возможные состояния приглашений */
export type Core_OrganizationInviteStatus =
  /** Принято */
  | 'approved'
  /** Инициировано */
  | 'initiated'
  /** Некорректно */
  | 'invalid'
  /** Отклонено */
  | 'rejected'
  /** Отправлено */
  | 'sent';

export type Core_OrganizationMutationNs_JoinDocumentInput = {
  date: string;
  /** Период действия договорного документа */
  durationYears: number;
  /** Место составления договорного документа */
  location: string;
  number: string;
};

export type Core_OrganizationMutationNs_UpdateOrganizationInputInput = {
  attributes?: Array<Core_OrganizationAttributeInput> | null | undefined;
  countryCode?: string | null | undefined;
  isSearchable?: boolean | null | undefined;
  name?: string | null | undefined;
};

export type Core_OrganizationPaymentOptionsMutationNs_CreateInputInput = {
  accountNumber: string;
  bankId: string;
  bankName: string;
  bic: string;
  corrAccountNumber: string;
  currency: string;
  docId: string;
  isDefault: boolean;
  name: string;
};

export type Core_OrganizationPaymentOptionsMutationNs_SetInputInput = {
  accountNumber: string;
  bankId: string;
  bankName: string;
  bic: string;
  corrAccountNumber: string;
  currency: string;
  docId: string;
  isDefault: boolean;
  name: string;
};

export type Core_OrganizationPaymentOptionsMutationNs_UpdateInputInput = {
  accountNumber?: string | null | undefined;
  bankId?: string | null | undefined;
  bankName?: string | null | undefined;
  bic?: string | null | undefined;
  corrAccountNumber?: string | null | undefined;
  currency?: string | null | undefined;
  docId?: string | null | undefined;
  isDefault?: boolean | null | undefined;
  name?: string | null | undefined;
};

export type Core_PoaInfoInput = {
  /** Утрата полномочий при передоверии */
  authorityLossFlag: boolean;
  expirationDate: string;
  id: string | number;
  issueDate: string;
  /** Возможность передоверия */
  retrust: Core_PoaInfoRetrustParameters;
};

export type Core_PoaInfoRetrustParameters =
  /** Передоверие с последующим передоверием */
  | 'multi_retrust'
  /** Без права передоверия */
  | 'no_retrust'
  /** Однократное передоверие */
  | 'single_retrust'
  /** Не установлено */
  | 'unset';

export type Core_PoaMutationNs_UpdateDraftInputAuthorityInvitationInput = {
  inn: string;
  /** Имя */
  name: string;
  /** Отчество */
  parentalName: string;
  /** Должность доверителя */
  position: string;
  snils: string;
  /** Фамилия */
  surname: string;
};

export type Core_PoaMutationNs_UpdateDraftInputInput = {
  /** Дата рождения доверителя ГГГГ-ММ-ДД */
  authorityBirthday: string;
  /** Гражданство доверителя */
  authorityCitizenship: string;
  /** Информация о доверителе для онбординга */
  authorityInvitation?:
    | Core_PoaMutationNs_UpdateDraftInputAuthorityInvitationInput
    | null
    | undefined;
  /** Сертификат ЕИО, указывать при сценарии онбординга */
  cert?: string | null | undefined;
  legalEntity?: Core_PoaMutationNs_UpdateDraftInputLegalEntityInput | null | undefined;
  /** Детали МЧД */
  poaInfo: Core_PoaInfoInput;
  /** Полномочия */
  powerDomain: Array<Core_PoaPowerDomainInput>;
  /** Организация получатель (контрагент) */
  recipientOrganizationID?: string | number | null | undefined;
  /** Представитель */
  representativeId: string | number;
};

export type Core_PoaMutationNs_UpdateDraftInputLegalEntityInput = {
  foundation: string;
  kpp: string;
};

export type Core_PoaPowerDomainInput = {
  code: string;
  content: string;
  textDescription: string;
};

export type Core_PoaQueryNs_PoaFormatEnum = 'xml';

export type Core_PoaQueryNs_QueryInputUserStatus =
  | 'active'
  | 'archived'
  | 'cancelled'
  | 'draft'
  | 'unset';

export type RevokeControlCardsMutationVariables = Exact<{
  documentIds: Array<string> | string;
}>;

export type RevokeControlCardsMutation = {
  app5182dd71_ControlCard: {
    terminate: { status: boolean; message: { ru: string; en: string } | null };
  };
};

export type SendToCorrectControlCardMutationVariables = Exact<{
  documentId: string;
}>;

export type SendToCorrectControlCardMutation = {
  app5182dd71_ControlCard: {
    sendToCorrect: { status: boolean; message: { ru: string; en: string } | null };
  };
};

export type UpdateControlCardMutationVariables = Exact<{
  documentId: string;
  input: App5182dd71_ControlCard_Update_Input;
}>;

export type UpdateControlCardMutation = {
  app5182dd71_ControlCard: { update: { id: string | null } };
};

export type CreateAgroDocumentMutationVariables = Exact<{
  input: App36c5da51_DocumentMutationNs_CreateInputInput;
}>;

export type CreateAgroDocumentMutation = {
  app36c5da51_Document: { create: { id: string | null } | null } | null;
};

export type CreateCessionDocumentMutationVariables = Exact<{
  input: App1d1b2841_DocumentMutationCession_CreateInputInput;
}>;

export type CreateCessionDocumentMutation = {
  app1d1b2841_Document: { create: { id: string | null } | null } | null;
};

export type CreateDocumentMutationVariables = Exact<{
  input: App70e9b8a9_DocumentMutationNs_CreateInputInput;
}>;

export type CreateDocumentMutation = {
  app70e9b8a9_Document: { create: { id: string | null } | null } | null;
};

export type CreateLicenseDocumentMutationVariables = Exact<{
  input: App5705572d_DocumentMutationNs_CreateInputInput;
}>;

export type CreateLicenseDocumentMutation = {
  app5705572d_Document: { create: { id: string | null } | null } | null;
};

export type CreateSupplyDocumentMutationVariables = Exact<{
  input: App12d801b5_DocumentMutationNpSupplyAgreement_CreateInputInput;
}>;

export type CreateSupplyDocumentMutation = {
  app12d801b5_Document: { create: { id: string | null } | null } | null;
};

export type CreateOperationalRequestMutationVariables = Exact<{
  input: App5182dd71_OperationalRequest_Create_Input;
  documentId?: string | null | undefined;
}>;

export type CreateOperationalRequestMutation = {
  app5182dd71_OperationalRequest: { create: { id: string | null } };
};

export type RevokeOperationalRequestMutationVariables = Exact<{
  documentIds: Array<string> | string;
}>;

export type RevokeOperationalRequestMutation = {
  app5182dd71_OperationalRequest: {
    terminate: { status: boolean; message: { ru: string; en: string } | null };
  };
};

export type SendToCorrectOperationalRequestMutationVariables = Exact<{
  documentId: string;
}>;

export type SendToCorrectOperationalRequestMutation = {
  app5182dd71_OperationalRequest: {
    sendToCorrect: { status: boolean; message: { ru: string; en: string } | null };
  };
};

export type NewShipmentRegistryMutationVariables = Exact<{
  input: App5182dd71_ShipmentReport_Create_Input;
}>;

export type NewShipmentRegistryMutation = {
  app5182dd71_ShipmentReport: {
    create: { status: boolean; message: { ru: string; en: string } | null };
  };
};

export type UpdateShipmentReportMutationVariables = Exact<{
  documentId: string;
}>;

export type UpdateShipmentReportMutation = {
  app5182dd71_ShipmentReport: {
    update: { status: boolean; message: { ru: string; en: string } | null };
  };
};

export type RevokeShipmentTasksMutationVariables = Exact<{
  documentIds: Array<string> | string;
}>;

export type RevokeShipmentTasksMutation = {
  app5182dd71_ShipmentTask: {
    terminate: { status: boolean; message: { ru: string; en: string } | null };
  };
};

export type SendToCorrectShipmentTaskMutationVariables = Exact<{
  documentId: string;
}>;

export type SendToCorrectShipmentTaskMutation = {
  app5182dd71_ShipmentTask: {
    sendToCorrect: { status: boolean; message: { ru: string; en: string } | null };
  };
};

export type UpdateShipmentTaskMutationVariables = Exact<{
  documentId: string;
  input: App5182dd71_ShipmentTask_Update_Input;
}>;

export type UpdateShipmentTaskMutation = {
  app5182dd71_ShipmentTask: { update: { id: string | null } };
};

export type SignDocumentMutationVariables = Exact<{
  documentId: string | number;
  documentVersion: number;
  detachedSignature?: string | null | undefined;
  signature?: string | null | undefined;
}>;

export type SignDocumentMutation = { coreDocuments: { sign: { result: boolean } } | null };

export type UpdateDocumentMutationVariables = Exact<{
  input: App70e9b8a9_DocumentMutationNs_UpdateInputInput;
}>;

export type UpdateDocumentMutation = {
  app70e9b8a9_Document: { update: { id: string | null } | null } | null;
};

export type CreateOrganizationDocumentMutationVariables = Exact<{
  file: File;
}>;

export type CreateOrganizationDocumentMutation = {
  coreOrganizationDocuments: { create: boolean } | null;
};

export type DeleteOrganizationDocumentMutationVariables = Exact<{
  id: string | number;
}>;

export type DeleteOrganizationDocumentMutation = {
  coreOrganizationDocuments: { delete: boolean } | null;
};

export type ConfirmInviteFromOrganizationMutationVariables = Exact<{
  inviteId: string | number;
  partnershipAgreement: boolean;
  signature?: string | null | undefined;
  detachedSignature?: string | null | undefined;
}>;

export type ConfirmInviteFromOrganizationMutation = {
  coreOrganizationInvitations: { confirmInvitation: boolean } | null;
};

export type FinishInviteOrganizationMutationVariables = Exact<{
  inviteId: string | number;
  signature?: string | null | undefined;
  detachedSignature?: string | null | undefined;
  sendInviteEmails?: Array<string> | string | null | undefined;
}>;

export type FinishInviteOrganizationMutation = {
  coreOrganizationInvitations: { finishInvite: { inviteId: string } } | null;
};

export type RejectInviteFromOrganizationMutationVariables = Exact<{
  inviteId: string | number;
  rejectReason?: string | null | undefined;
}>;

export type RejectInviteFromOrganizationMutation = {
  coreOrganizationInvitations: { confirmInvitation: boolean } | null;
};

export type StartInviteOrganizationMutationVariables = Exact<{
  partnerOrganizationId: string | number;
  joinDocument?: Core_OrganizationMutationNs_JoinDocumentInput | null | undefined;
}>;

export type StartInviteOrganizationMutation = {
  coreOrganizationInvitations: {
    startInvite: { joinDocumentContent: string | null; inviteId: string };
  } | null;
};

export type FinishRegistrationByRepresentativeMutationVariables = Exact<{
  poaId: string | number;
  inviteId: string | number;
  signature: string;
  detachedSignature?: string | null | undefined;
}>;

export type FinishRegistrationByRepresentativeMutation = {
  coreOrganizations: { finishRegistrationByRepresentative: { organizationId: string } } | null;
};

export type PrepareOrganizationMutationVariables = Exact<{
  organizationAttributes:
    | Array<Core_OrganizationAttributeInput>
    | Core_OrganizationAttributeInput;
}>;

export type PrepareOrganizationMutation = {
  coreOrganizations: {
    prepare: {
      isRegistered: boolean;
      inviteId: string | null;
      organization: {
        id: string;
        name: string;
        status: number;
        type: number;
        countryCode: string;
        createdAt: string;
        updatedAt: string;
        attributes: Array<{ name: string; value: string }>;
      };
    };
  } | null;
};

export type StartRegistrationByRepresentativeMutationVariables = Exact<{
  poaId: string | number;
  inviteId: string | number;
}>;

export type StartRegistrationByRepresentativeMutation = {
  coreOrganizations: {
    startRegistrationByRepresentative: { joinDocumentContent: string };
  } | null;
};

export type UpdateMyOrganizationsMutationVariables = Exact<{
  input: Core_OrganizationMutationNs_UpdateOrganizationInputInput;
}>;

export type UpdateMyOrganizationsMutation = {
  coreOrganizations: {
    update: {
      createdAt: string;
      updatedAt: string;
      countryCode: string;
      type: number;
      status: number;
      id: string;
      name: string;
      attributes: Array<{ name: string; value: string }>;
    };
  } | null;
};

export type CreatePaymentOptionsMutationVariables = Exact<{
  input: Core_OrganizationPaymentOptionsMutationNs_CreateInputInput;
}>;

export type CreatePaymentOptionsMutation = {
  coreOrganizationPaymentOptions: {
    create: {
      id: string | null;
      name: string;
      isDefault: boolean;
      accountNumber: string;
      corrNumber: string;
      bic: string;
      currency: string;
      docId: string;
      bank: {
        id: string;
        name: string;
        status: number;
        type: number;
        countryCode: string;
        createdAt: string;
        updatedAt: string;
        attributes: Array<{ name: string; value: string }>;
      };
    };
  } | null;
};

export type SetPaymentOptionsMutationVariables = Exact<{
  input: Core_OrganizationPaymentOptionsMutationNs_SetInputInput;
}>;

export type SetPaymentOptionsMutation = {
  coreOrganizationPaymentOptions: {
    set: {
      id: string | null;
      name: string;
      isDefault: boolean;
      accountNumber: string;
      corrNumber: string;
      bic: string;
      currency: string;
      docId: string;
      bank: {
        id: string;
        name: string;
        status: number;
        type: number;
        countryCode: string;
        createdAt: string;
        updatedAt: string;
        attributes: Array<{ name: string; value: string }>;
      };
    };
  } | null;
};

export type UpdatePaymentOptionsMutationVariables = Exact<{
  input: Core_OrganizationPaymentOptionsMutationNs_UpdateInputInput;
  id: string | number;
}>;

export type UpdatePaymentOptionsMutation = {
  coreOrganizationPaymentOptions: {
    update: {
      id: string | null;
      name: string;
      isDefault: boolean;
      accountNumber: string;
      corrNumber: string;
      bic: string;
      currency: string;
      docId: string;
      bank: {
        id: string;
        name: string;
        status: number;
        type: number;
        countryCode: string;
        createdAt: string;
        updatedAt: string;
        attributes: Array<{ name: string; value: string }>;
      };
    };
  } | null;
};

export type CreatePoaDraftMutationVariables = Exact<{
  inviteId?: string | number | null | undefined;
}>;

export type CreatePoaDraftMutation = { corePOA: { createDraft: string } | null };

export type PoaRevokeMutationVariables = Exact<{
  id: string | number;
  signature: string;
  detachedSignature?: string | null | undefined;
}>;

export type PoaRevokeMutation = { corePOA: { revoke: boolean } | null };

export type PoaSignMutationVariables = Exact<{
  id: string | number;
  signature: string;
  detachedSignature?: string | null | undefined;
  cert?: string | null | undefined;
}>;

export type PoaSignMutation = { corePOA: { sign: boolean } | null };

export type SendEmailToAuthorityMutationVariables = Exact<{
  email: string;
  cert: string;
  poaID: string;
}>;

export type SendEmailToAuthorityMutation = {
  corePOA: { sendPOANotificationToAuthority: boolean } | null;
};

export type UpdatePoaDraftMutationVariables = Exact<{
  input?: Core_PoaMutationNs_UpdateDraftInputInput | null | undefined;
}>;

export type UpdatePoaDraftMutation = { corePOA: { updateDraft: boolean } | null };

export type CreatePoaUserMutationVariables = Exact<{
  userType: string;
  request: unknown;
}>;

export type CreatePoaUserMutation = { corePOAUsers: { createRepresentative: string } | null };

export type UpdatePoaUserMutationVariables = Exact<{
  userId: string | number;
  userType: string;
  data: unknown;
}>;

export type UpdatePoaUserMutation = { corePOAUsers: { updateData: boolean } | null };

export type AcceptStaffInviteMutationVariables = Exact<{
  invitationId: string | number;
}>;

export type AcceptStaffInviteMutation = {
  coreEmployeeInvitations: { acceptInvitation: boolean } | null;
};

export type InviteStaffMutationVariables = Exact<{
  participantData: Core_EmployeeInvitationMutationNs_InviteUnregisteredEmployeeInputInput;
  role: Core_EmployeeRole;
  type: Core_EmployeeType;
  position: string;
}>;

export type InviteStaffMutation = { coreEmployeeInvitations: { invite: string } | null };

export type RejectStaffInviteMutationVariables = Exact<{
  invitationId: string | number;
}>;

export type RejectStaffInviteMutation = {
  coreEmployeeInvitations: { acceptInvitation: boolean } | null;
};

export type GetCoreDictionariesBanksQueryVariables = Exact<{ [key: string]: never }>;

export type GetCoreDictionariesBanksQuery = {
  coreOrganizations: {
    queryBanks: {
      organizations: Array<{
        id: string;
        name: string;
        status: number;
        type: number;
        countryCode: string;
        createdAt: string;
        updatedAt: string;
      }>;
    };
  } | null;
};

export type GetCoreDictionariesCountriesQueryVariables = Exact<{ [key: string]: never }>;

export type GetCoreDictionariesCountriesQuery = {
  coreDictionaries: {
    get: Array<{
      id: string;
      appId: string;
      alias: string;
      title: string;
      description: string | null;
      createdAt: unknown;
      updatedAt: unknown;
      enums: Array<{
        id: string;
        title: string;
        values: Array<{ key: string; value: string | null }>;
      }>;
    }>;
  } | null;
};

export type GetAllControlCardsQueryVariables = Exact<{
  statusIds?: Array<string> | string | null | undefined;
  input?: string | null | undefined;
  agreementId?: string | null | undefined;
  shippingDateBefore?: string | null | undefined;
  shippingDateAfter?: string | null | undefined;
}>;

export type GetAllControlCardsQuery = {
  app5182dd71_ControlCard: {
    getList: {
      data: Array<{
        id: string;
        version: number;
        statusId: string;
        actualShipmentDate: string | null;
        actualQuantity: number | null;
        createdAt: string;
        updatedAt: string;
        shipmentTask: {
          id: string;
          version: number;
          statusId: string;
          supplierExecutor: string | null;
          buyerExecutor: string | null;
          createdAt: string;
          updatedAt: string;
          operationalRequest: {
            id: string;
            orgOwnerId: string;
            agreementName: string;
            number: number;
            requestDate: string;
            deliveryBasis: string;
            supplyAddress: string;
            shippingDate: string;
            goodsType: string;
            quantity: number;
            statusId: string;
            employeeOwner: string | null;
            employeeReceiving: string | null;
            comment: string | null;
          };
        };
      }>;
      meta: { page: number; limit: number; total: number };
    };
  };
};

export type GetControlCardSchemeQueryVariables = Exact<{
  documentId: string;
}>;

export type GetControlCardSchemeQuery = {
  app5182dd71_ControlCard: {
    getTemplate: {
      template: Array<{
        step: number;
        name: string;
        type: string | null;
        required: boolean;
        disabled: boolean;
        isSearchable: boolean | null;
        placeholder: string | null;
        fieldTransform: string | null;
        fieldType: string;
        isVisible: string | null;
        isVisibleDependency: string | null;
        stepLabel: string;
        validation: string | null;
        optionsDependency: string | null;
        value: string | null;
        label: { ru: string; en: string };
        optionsDependentSelect: Array<{
          value: string;
          options: Array<{ label: string; value: string }>;
        }> | null;
        options: Array<{ label: string; value: string }> | null;
      }> | null;
    };
  };
};

export type GetOneControlCardQueryVariables = Exact<{
  documentId: string;
}>;

export type GetOneControlCardQuery = {
  app5182dd71_ControlCard: {
    getOne: {
      id: string;
      version: number;
      statusId: string;
      actualShipmentDate: string | null;
      actualQuantity: number | null;
      createdAt: string;
      updatedAt: string;
      shipmentTask: {
        id: string;
        version: number;
        statusId: string;
        supplierExecutor: string | null;
        buyerExecutor: string | null;
        createdAt: string;
        updatedAt: string;
        operationalRequest: {
          id: string;
          orgOwnerId: string;
          agreementName: string;
          number: number;
          requestDate: string;
          deliveryBasis: string;
          supplyAddress: string;
          goodsType: string;
          quantity: number;
          statusId: string;
          employeeOwner: string | null;
          employeeReceiving: string | null;
          comment: string | null;
        };
      };
    };
  };
};

export type GetCoreDocumentStatusesQueryVariables = Exact<{ [key: string]: never }>;

export type GetCoreDocumentStatusesQuery = {
  coreDocuments: {
    getStatuses: Array<{ id: string; alias: string; appId: { id: string } }>;
  } | null;
};

export type GetCoreDocumentsListQueryVariables = Exact<{
  statuses?: Array<string> | string | null | undefined;
  searchText?: string | null | undefined;
  signatureTypes?:
    | Array<Core_DocumentSignatureType>
    | Core_DocumentSignatureType
    | null
    | undefined;
}>;

export type GetCoreDocumentsListQuery = {
  coreDocuments: {
    query: {
      documents: Array<{
        id: string;
        title: string;
        number: string;
        typeId: string;
        docDate: unknown;
        version: number;
        statusId: string;
        createdAt: unknown;
        updatedAt: unknown;
        contractors: Array<{ id: string; name: string }> | null;
        template: { id: string } | null;
        orgOwner: {
          id: string;
          name: string;
          status: number;
          type: number;
          countryCode: string;
          createdAt: string;
          updatedAt: string;
        } | null;
      }>;
    };
  } | null;
};

export type GetCoreDocumentsQueryVariables = Exact<{
  documentIds: Array<string | number> | string | number;
}>;

export type GetCoreDocumentsQuery = {
  coreDocuments: {
    get: Array<{
      id: string;
      typeId: string;
      title: string;
      tbs: string;
      number: string;
      docDate: unknown;
      version: number;
      statusId: string;
      createdAt: unknown;
      updatedAt: unknown;
      validFrom: unknown;
      validTo: unknown;
      tbd: Array<{ type: Core_DocumentsDisplayableType; content: string }>;
      signatures: Array<{
        id: string;
        documentID: string;
        employeeID: string;
        organizationID: string;
        committed: boolean;
        type: Core_DocumentSignatureType;
        createdAt: unknown;
        updatedAt: unknown;
        revisions: Array<{
          signatureID: string;
          key: string;
          hash: string;
          body: string | null;
        }> | null;
      }> | null;
      contractors: Array<{ id: string; name: string }> | null;
      template: { id: string } | null;
      orgOwner: {
        id: string;
        name: string;
        status: number;
        type: number;
        countryCode: string;
        createdAt: string;
        updatedAt: string;
      } | null;
      parameters: Array<{ name: string; value: string }>;
    }>;
  } | null;
};

export type GetDocumentAgroproductionSchemeQueryVariables = Exact<{
  documentId?: string | null | undefined;
}>;

export type GetDocumentAgroproductionSchemeQuery = {
  app36c5da51_Document: {
    getTemplate: {
      template: Array<{
        step: number | null;
        name: string | null;
        type: string | null;
        required: boolean | null;
        isSearchable: boolean | null;
        placeholder: string | null;
        fieldTransform: string | null;
        fieldType: string | null;
        stepLabel: string | null;
        validation: string | null;
        value: string | null;
        label: { ru: string | null; en: string | null } | null;
        options: Array<{ label: string | null; value: string | null } | null> | null;
      } | null> | null;
    } | null;
  } | null;
};

export type GetDocumentCessionSchemeQueryVariables = Exact<{
  documentId?: string | null | undefined;
}>;

export type GetDocumentCessionSchemeQuery = {
  app1d1b2841_Document: {
    getTemplate: {
      template: Array<{
        step: number | null;
        name: string | null;
        type: string | null;
        value: string | null;
        required: boolean | null;
        isSearchable: boolean | null;
        placeholder: string | null;
        fieldTransform: string | null;
        fieldType: string | null;
        stepLabel: string | null;
        validation: string | null;
        label: { en: string | null; ru: string | null } | null;
        options: Array<{ label: string | null; value: string | null } | null> | null;
      } | null> | null;
    } | null;
  } | null;
};

export type GetDocumentLicencesSchemeQueryVariables = Exact<{
  templateId: string;
  documentId?: string | null | undefined;
}>;

export type GetDocumentLicencesSchemeQuery = {
  app5705572d_Document: {
    getTemplate: {
      template: Array<{
        step: number | null;
        name: string | null;
        type: string | null;
        value: string | null;
        required: boolean | null;
        isSearchable: boolean | null;
        placeholder: string | null;
        fieldType: string | null;
        fieldTransform: string | null;
        stepLabel: string | null;
        validation: string | null;
        label: { en: string | null; ru: string | null } | null;
        options: Array<{ label: string | null; value: string | null } | null> | null;
      } | null> | null;
    } | null;
  } | null;
};

export type GetDocumentSchemeQueryVariables = Exact<{
  documentId?: string | null | undefined;
}>;

export type GetDocumentSchemeQuery = {
  app70e9b8a9_Document: {
    getTemplate: {
      template: Array<{
        step: number | null;
        name: string | null;
        type: string | null;
        value: string | null;
        required: boolean | null;
        isSearchable: boolean | null;
        placeholder: string | null;
        fieldTransform: string | null;
        fieldType: string | null;
        stepLabel: string | null;
        validation: string | null;
        label: { en: string | null; ru: string | null } | null;
        options: Array<{ label: string | null; value: string | null } | null> | null;
      } | null> | null;
    } | null;
  } | null;
};

export type GetDocumentSupplySchemeQueryVariables = Exact<{
  documentId?: string | null | undefined;
}>;

export type GetDocumentSupplySchemeQuery = {
  app12d801b5_Document: {
    getTemplate: {
      template: Array<{
        step: number | null;
        name: string | null;
        type: string | null;
        value: string | null;
        required: boolean | null;
        isSearchable: boolean | null;
        placeholder: string | null;
        fieldTransform: string | null;
        fieldType: string | null;
        stepLabel: string | null;
        validation: string | null;
        label: { en: string | null; ru: string | null } | null;
        options: Array<{ label: string | null; value: string | null } | null> | null;
      } | null> | null;
    } | null;
  } | null;
};

export type GetDocumentsTemplatesQueryVariables = Exact<{ [key: string]: never }>;

export type GetDocumentsTemplatesQuery = {
  coreDocumentTemplates: {
    getPublic: {
      templates: Array<{
        id: string;
        typeId: string;
        title: string;
        alias: string;
        description: string;
        path: string | null;
        api: string | null;
        createdAt: unknown;
        updatedAt: unknown;
        application: { id: string; traits: Array<Core_ApplicationTrait>; alias: string } | null;
      }>;
    };
  } | null;
};

export type GetAllOperationalRequestsQueryVariables = Exact<{
  statusIds?: Array<string> | string | null | undefined;
  input?: string | null | undefined;
  agreementId?: string | null | undefined;
  shippingDateBefore?: string | null | undefined;
  shippingDateAfter?: string | null | undefined;
}>;

export type GetAllOperationalRequestsQuery = {
  app5182dd71_OperationalRequest: {
    getList: {
      data: Array<{
        id: string;
        version: number;
        statusId: string;
        orgOwnerId: string;
        employeeOwner: string | null;
        employeeReceiving: string | null;
        agreementName: string;
        number: number;
        requestDate: string;
        shippingDate: string;
        deliveryBasis: string;
        supplyAddress: string;
        goodsType: string;
        quantity: number;
        createdAt: string;
        updatedAt: string;
      }>;
      meta: { page: number; limit: number; total: number };
    };
  };
};

export type GetOneOperationalRequestQueryVariables = Exact<{
  documentId: string;
}>;

export type GetOneOperationalRequestQuery = {
  app5182dd71_OperationalRequest: {
    getOne: {
      id: string;
      number: number;
      agreementName: string;
      version: number;
      statusId: string;
      orgOwnerId: string;
      employeeOwner: string | null;
      employeeReceiving: string | null;
      requestDate: string;
      shippingDate: string;
      deliveryBasis: string;
      supplyAddress: string;
      goodsType: string;
      quantity: number;
      comment: string | null;
      createdAt: string;
      updatedAt: string;
    };
  };
};

export type GetOperationalRequestFiltersQueryVariables = Exact<{ [key: string]: never }>;

export type GetOperationalRequestFiltersQuery = {
  app5182dd71_OperationalRequest: {
    getFilterOptions: { agreementId: Array<{ key: string; valStr: string }> };
  };
};

export type GetOperationalRequestSchemeQueryVariables = Exact<{
  documentId?: string | null | undefined;
}>;

export type GetOperationalRequestSchemeQuery = {
  app5182dd71_OperationalRequest: {
    getTemplate: {
      template: Array<{
        step: number;
        name: string;
        type: string | null;
        required: boolean;
        disabled: boolean;
        isSearchable: boolean | null;
        placeholder: string | null;
        fieldTransform: string | null;
        fieldType: string;
        isVisible: string | null;
        isVisibleDependency: string | null;
        stepLabel: string;
        validation: string | null;
        optionsDependency: string | null;
        value: string | null;
        label: { ru: string; en: string };
        optionsDependentSelect: Array<{
          value: string;
          options: Array<{ label: string; value: string }>;
        }> | null;
        options: Array<{ label: string; value: string }> | null;
      }> | null;
    };
  };
};

export type GetAllShipmentRegistriesQueryVariables = Exact<{
  filters?: App5182dd71_ShipmentRegistry_FiltersInput | null | undefined;
}>;

export type GetAllShipmentRegistriesQuery = {
  app5182dd71_ShipmentRegistry: {
    getList: {
      data: Array<{
        id: string;
        version: number;
        statusId: string;
        number: string;
        period: string;
        buyerInn: string;
        buyerKpp: string;
        buyer: string;
        document: string;
        agreement: string;
        total: number;
        invoiceNumber: string | null;
        invoiceDate: string | null;
        invoiceTotal: string | null;
        createdAt: string;
        updatedAt: string;
      }>;
      meta: { page: number; limit: number; total: number };
    };
  };
};

export type GetOneShipmentRegistryQueryVariables = Exact<{
  documentId: string;
}>;

export type GetOneShipmentRegistryQuery = {
  app5182dd71_ShipmentRegistry: {
    getOne: {
      id: string;
      version: number;
      statusId: string;
      number: string;
      period: string;
      buyerInn: string;
      buyerKpp: string;
      buyer: string;
      document: string;
      agreement: string;
      total: number;
      invoiceNumber: string | null;
      invoiceDate: string | null;
      invoiceTotal: string | null;
      createdAt: string;
      updatedAt: string;
    };
  };
};

export type GetShipmentRegistrySchemeQueryVariables = Exact<{
  documentId: string;
}>;

export type GetShipmentRegistrySchemeQuery = {
  app5182dd71_ShipmentRegistry: {
    getTemplate: {
      template: Array<{
        step: number;
        name: string;
        type: string | null;
        required: boolean;
        disabled: boolean;
        isSearchable: boolean | null;
        placeholder: string | null;
        fieldTransform: string | null;
        fieldType: string;
        isVisible: string | null;
        isVisibleDependency: string | null;
        stepLabel: string;
        validation: string | null;
        optionsDependency: string | null;
        value: string | null;
        label: { ru: string; en: string };
        options: Array<{ label: string; value: string }> | null;
        optionsDependentSelect: Array<{
          value: string;
          options: Array<{ label: string; value: string }>;
        }> | null;
      }> | null;
    };
  };
};

export type GetAllShipmentReportsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllShipmentReportsQuery = {
  app5182dd71_ShipmentReport: {
    getList: {
      data: Array<{
        id: string;
        number: number;
        document: string;
        agreement: string;
        period: string;
        quantity: number;
        statusId: string;
        orgSupplier: string;
        orgBuyer: string;
      }>;
      meta: { page: number; limit: number; total: number };
    };
  };
};

export type GetOneShipmentReportQueryVariables = Exact<{
  documentId: string;
}>;

export type GetOneShipmentReportQuery = {
  app5182dd71_ShipmentReport: {
    getOne: {
      id: string;
      number: number;
      document: string;
      agreement: string;
      period: string;
      quantity: number;
      statusId: string;
      orgSupplier: string;
      orgBuyer: string;
      data: unknown;
    };
  };
};

export type GetTemplateShipmentReportsQueryVariables = Exact<{ [key: string]: never }>;

export type GetTemplateShipmentReportsQuery = {
  app5182dd71_ShipmentReport: {
    getTemplate: {
      template: Array<{
        step: number;
        name: string;
        type: string | null;
        value: string | null;
        required: boolean;
        disabled: boolean;
        isVisibleDependency: string | null;
        isSearchable: boolean | null;
        optionsDependency: string | null;
        placeholder: string | null;
        fieldTransform: string | null;
        fieldType: string;
        stepLabel: string;
        validation: string | null;
        label: { en: string; ru: string };
        options: Array<{ label: string; value: string }> | null;
      }> | null;
    };
  };
};

export type GetAllShipmentTasksQueryVariables = Exact<{
  agreementId?: string | null | undefined;
  input?: string | null | undefined;
  shippingDateBefore?: string | null | undefined;
  shippingDateAfter?: string | null | undefined;
  statusIds?: Array<string> | string | null | undefined;
}>;

export type GetAllShipmentTasksQuery = {
  app5182dd71_ShipmentTask: {
    getList: {
      data: Array<{
        id: string;
        version: number;
        statusId: string;
        supplierExecutor: string | null;
        buyerExecutor: string | null;
        createdAt: string;
        updatedAt: string;
        operationalRequest: {
          id: string;
          orgOwnerId: string;
          agreementName: string;
          number: number;
          requestDate: string;
          shippingDate: string;
          deliveryBasis: string;
          supplyAddress: string;
          goodsType: string;
          quantity: number;
          statusId: string;
          employeeOwner: string | null;
          employeeReceiving: string | null;
          comment: string | null;
        };
      }>;
      meta: { page: number; limit: number; total: number };
    };
  };
};

export type GetOneShipmentTaskQueryVariables = Exact<{
  documentId: string;
}>;

export type GetOneShipmentTaskQuery = {
  app5182dd71_ShipmentTask: {
    getOne: {
      id: string;
      version: number;
      statusId: string;
      supplierExecutor: string | null;
      buyerExecutor: string | null;
      createdAt: string;
      updatedAt: string;
      operationalRequest: {
        id: string;
        orgOwnerId: string;
        agreementName: string;
        number: number;
        requestDate: string;
        shippingDate: string;
        deliveryBasis: string;
        supplyAddress: string;
        goodsType: string;
        quantity: number;
        statusId: string;
        employeeOwner: string | null;
        employeeReceiving: string | null;
        comment: string | null;
      };
    };
  };
};

export type GetShipmentTasksSchemeQueryVariables = Exact<{
  documentId: string;
}>;

export type GetShipmentTasksSchemeQuery = {
  app5182dd71_ShipmentTask: {
    getTemplate: {
      template: Array<{
        step: number;
        name: string;
        type: string | null;
        value: string | null;
        required: boolean;
        disabled: boolean;
        isSearchable: boolean | null;
        placeholder: string | null;
        fieldTransform: string | null;
        fieldType: string;
        stepLabel: string;
        validation: string | null;
        label: { en: string; ru: string };
        options: Array<{ label: string; value: string }> | null;
      }> | null;
    };
  };
};

export type GetContractorOrganizationDocumentsQueryVariables = Exact<{
  contractorId: string | number;
}>;

export type GetContractorOrganizationDocumentsQuery = {
  coreOrganizationDocuments: {
    contractorDocuments: {
      documents: Array<{
        id: string;
        createdAt: string;
        updatedAt: string;
        name: string;
        extension: string;
        size: number;
      }>;
    };
  } | null;
};

export type GetMyOrganizationDocumentsQueryVariables = Exact<{ [key: string]: never }>;

export type GetMyOrganizationDocumentsQuery = {
  coreOrganizationDocuments: {
    myDocuments: {
      documents: Array<{
        id: string;
        createdAt: string;
        updatedAt: string;
        name: string;
        extension: string;
        size: number;
      }>;
    };
  } | null;
};

export type GetMyIncomingInvitationsCountQueryVariables = Exact<{ [key: string]: never }>;

export type GetMyIncomingInvitationsCountQuery = {
  coreOrganizationInvitations: { count: number | null } | null;
};

export type GetMyIncomingInvitationsQueryVariables = Exact<{ [key: string]: never }>;

export type GetMyIncomingInvitationsQuery = {
  coreOrganizationInvitations: {
    query: {
      invites: Array<{
        id: string;
        status: Core_OrganizationInviteStatus;
        joinDocumentId: string | null;
        createdAt: string;
        updatedAt: string;
        isIncoming: boolean;
        partyOrganization: {
          id: string;
          name: string;
          status: number;
          type: number;
          countryCode: string;
          createdAt: string;
          updatedAt: string;
          attributes: Array<{ name: string; value: string }>;
        } | null;
      }>;
    };
  } | null;
};

export type GetMyOutgoingInvitationsCountQueryVariables = Exact<{ [key: string]: never }>;

export type GetMyOutgoingInvitationsCountQuery = {
  coreOrganizationInvitations: { count: number | null } | null;
};

export type GetMyOutgoingInvitationsQueryVariables = Exact<{ [key: string]: never }>;

export type GetMyOutgoingInvitationsQuery = {
  coreOrganizationInvitations: {
    query: {
      invites: Array<{
        id: string;
        status: Core_OrganizationInviteStatus;
        joinDocumentId: string | null;
        createdAt: string;
        updatedAt: string;
        isIncoming: boolean;
        partyOrganization: {
          id: string;
          name: string;
          status: number;
          type: number;
          countryCode: string;
          createdAt: string;
          updatedAt: string;
          attributes: Array<{ name: string; value: string }>;
        } | null;
      }>;
    };
  } | null;
};

export type GetCoreOrganizationsParticipationsQueryVariables = Exact<{ [key: string]: never }>;

export type GetCoreOrganizationsParticipationsQuery = {
  coreOrganizationParticipations: {
    my: Array<{
      id: string;
      role: string;
      application: {
        alias: string;
        widgets: Array<{
          id: string;
          header: string;
          fields: Array<{
            id: string;
            viewName: string;
            viewIndex: number;
            access: Array<string> | null;
            path: string;
            api: string;
          }> | null;
        }> | null;
      };
    }> | null;
  } | null;
};

export type GetCoreOrganizationsQueryVariables = Exact<{
  searchText?: string | null | undefined;
}>;

export type GetCoreOrganizationsQuery = {
  coreOrganizations: {
    query: {
      organizations: Array<{
        id: string;
        name: string;
        status: number;
        type: number;
        countryCode: string;
        createdAt: string;
        updatedAt: string;
        attributes: Array<{ value: string; name: string }>;
      }>;
    };
  } | null;
};

export type GetMyOrganizationsQueryVariables = Exact<{ [key: string]: never }>;

export type GetMyOrganizationsQuery = {
  coreOrganizations: {
    my: Array<{
      id: string;
      name: string;
      status: number;
      type: number;
      countryCode: string;
      createdAt: string;
      updatedAt: string;
      attributes: Array<{ name: string; value: string }>;
    }>;
  } | null;
};

export type GetOrganizationQueryVariables = Exact<{
  ids: Array<string | number> | string | number;
}>;

export type GetOrganizationQuery = {
  coreOrganizations: {
    get: Array<{
      id: string;
      name: string;
      status: number;
      type: number;
      countryCode: string;
      createdAt: string;
      updatedAt: string;
      attributes: Array<{ name: string; value: string }>;
    }>;
  } | null;
};

export type GetPartnerOrganizationQueryVariables = Exact<{
  id: string | number;
}>;

export type GetPartnerOrganizationQuery = {
  coreOrganizations: {
    getPartner: {
      partnership_agreement_date: string;
      organization: {
        id: string;
        name: string;
        status: number;
        type: number;
        countryCode: string;
        createdAt: string;
        updatedAt: string;
        attributes: Array<{ name: string; value: string }>;
      };
      default_payment_option: {
        id: string | null;
        name: string;
        isDefault: boolean;
        accountNumber: string;
        corrNumber: string;
        bic: string;
        currency: string;
        docId: string;
        bank: {
          id: string;
          name: string;
          status: number;
          type: number;
          countryCode: string;
          createdAt: string;
          updatedAt: string;
        };
      } | null;
    };
  } | null;
};

export type GetPartnersOrganizationsQueryVariables = Exact<{
  searchText?: string | null | undefined;
}>;

export type GetPartnersOrganizationsQuery = {
  coreOrganizations: {
    getPartners: {
      organizations: Array<{
        id: string;
        name: string;
        status: number;
        type: number;
        countryCode: string;
        createdAt: string;
        updatedAt: string;
        attributes: Array<{ name: string; value: string }>;
      }>;
    };
  } | null;
};

export type GetMyPaymentOptionsQueryVariables = Exact<{ [key: string]: never }>;

export type GetMyPaymentOptionsQuery = {
  coreOrganizationPaymentOptions: {
    my: Array<{
      id: string | null;
      name: string;
      isDefault: boolean;
      accountNumber: string;
      corrNumber: string;
      bic: string;
      currency: string;
      docId: string;
      bank: {
        id: string;
        name: string;
        status: number;
        type: number;
        countryCode: string;
        createdAt: string;
        updatedAt: string;
        attributes: Array<{ name: string; value: string }>;
      };
    }>;
  } | null;
};

export type GetLinkForAuthorityQueryVariables = Exact<{
  poaId: string | number;
  inviteId: string | number;
}>;

export type GetLinkForAuthorityQuery = { corePOA: { getLinkForAuthority: string } | null };

export type GetListRetrustPoaQueryVariables = Exact<{ [key: string]: never }>;

export type GetListRetrustPoaQuery = {
  corePOA: {
    listRetrustPOAs: Array<{
      retrustPoaInfo: {
        id: string;
        number: string;
        issueDate: string;
        expirationDate: string;
        revocationDate: string | null;
        createdAt: string;
        updatedAt: string;
        status: PoaStatus;
        content: string | null;
        retrust: Core_PoaInfoRetrustParameters;
        authority: { id: string; userType: string; rawUserInfo: string };
        recipientOrganization: {
          id: string;
          name: string;
          status: number;
          type: number;
          countryCode: string;
          createdAt: string;
          updatedAt: string;
          attributes: Array<{ name: string; value: string }>;
        } | null;
        representative: { id: string; userType: string; rawUserInfo: string };
        powerDomain: Array<{ code: string; textDescription: string; content: string } | null>;
        parentPOA: {
          id: string;
          issueDate: string;
          expirationDate: string;
          retrustFlag: boolean;
          authorityLossFlag: boolean;
          retrust: Core_PoaInfoRetrustParameters;
        } | null;
      };
      rootPOAInfo: {
        id: string;
        number: string;
        issueDate: string;
        expirationDate: string;
        revocationDate: string | null;
        createdAt: string;
        updatedAt: string;
        status: PoaStatus;
        content: string | null;
        retrust: Core_PoaInfoRetrustParameters;
        authority: { id: string; userType: string; rawUserInfo: string };
        recipientOrganization: {
          id: string;
          name: string;
          status: number;
          type: number;
          countryCode: string;
          createdAt: string;
          updatedAt: string;
          attributes: Array<{ name: string; value: string }>;
        } | null;
        representative: { id: string; userType: string; rawUserInfo: string };
        powerDomain: Array<{ code: string; textDescription: string; content: string } | null>;
        parentPOA: {
          id: string;
          issueDate: string;
          expirationDate: string;
          retrustFlag: boolean;
          authorityLossFlag: boolean;
          retrust: Core_PoaInfoRetrustParameters;
        } | null;
        delegatedPOAs: Array<{
          id: string;
          issueDate: string;
          expirationDate: string;
          retrustFlag: boolean;
          authorityLossFlag: boolean;
          retrust: Core_PoaInfoRetrustParameters;
        }>;
      };
    }>;
  } | null;
};

export type GetPoaDraftForAuthorityQueryVariables = Exact<{
  cert: string;
  id: string | number;
}>;

export type GetPoaDraftForAuthorityQuery = {
  corePOA: {
    getDraft: {
      id: string;
      number: string;
      issueDate: string;
      expirationDate: string;
      revocationDate: string | null;
      createdAt: string;
      updatedAt: string;
      status: PoaStatus;
      content: string | null;
      retrust: Core_PoaInfoRetrustParameters;
      authority: { id: string; userType: string; rawUserInfo: string };
      recipientOrganization: {
        id: string;
        name: string;
        status: number;
        type: number;
        countryCode: string;
        createdAt: string;
        updatedAt: string;
        attributes: Array<{ name: string; value: string }>;
      } | null;
      representative: { id: string; userType: string; rawUserInfo: string };
      powerDomain: Array<{ code: string; textDescription: string; content: string } | null>;
      parentPOA: {
        retrust: Core_PoaInfoRetrustParameters;
        authorityLossFlag: boolean;
        retrustFlag: boolean;
      } | null;
    };
  } | null;
};

export type GetPoaDraftsAndXmlQueryVariables = Exact<{
  id: string | number;
  format?: Core_PoaQueryNs_PoaFormatEnum | null | undefined;
}>;

export type GetPoaDraftsAndXmlQuery = {
  corePOA: {
    getDraft: {
      id: string;
      number: string;
      issueDate: string;
      expirationDate: string;
      revocationDate: string | null;
      createdAt: string;
      updatedAt: string;
      status: PoaStatus;
      content: string | null;
      authority: { id: string; userType: string; rawUserInfo: string };
      recipientOrganization: {
        id: string;
        name: string;
        status: number;
        type: number;
        countryCode: string;
        createdAt: string;
        updatedAt: string;
      } | null;
      representative: { id: string; userType: string; rawUserInfo: string };
      powerDomain: Array<{ code: string; textDescription: string; content: string } | null>;
    };
  } | null;
};

export type GetPoaDraftsListQueryVariables = Exact<{
  representativeEmployeeID?: string | number | null | undefined;
  status?: Core_PoaQueryNs_QueryInputUserStatus | null | undefined;
}>;

export type GetPoaDraftsListQuery = {
  corePOA: {
    query: {
      poas: Array<{
        poaDraft: {
          id: string;
          number: string;
          issueDate: string;
          status: PoaStatus;
          updatedAt: string;
          createdAt: string;
          expirationDate: string;
          revocationDate: string | null;
          representative: { id: string; userType: string; rawUserInfo: string };
          authority: { id: string; userType: string; rawUserInfo: string };
          recipientOrganization: {
            id: string;
            name: string;
            status: number;
            type: number;
            countryCode: string;
            createdAt: string;
            updatedAt: string;
          } | null;
          powerDomain: Array<{ code: string; textDescription: string; content: string } | null>;
        };
        authority: { id: string; userType: string; rawUserInfo: string };
        representative: { id: string; userType: string; rawUserInfo: string };
      }>;
    };
  } | null;
};

export type GetPoaSignedRevocationQueryVariables = Exact<{
  poaId: string | number;
}>;

export type GetPoaSignedRevocationQuery = {
  corePOA: {
    getSignedRevocation: {
      revocation: { poaID: string; content: string; filename: string; createdAt: string };
    };
  } | null;
};

export type GetPoaSignedXmlQueryVariables = Exact<{
  poaId: string | number;
}>;

export type GetPoaSignedXmlQuery = {
  corePOA: { getSignedById: { name: string; contents: string } } | null;
};

export type PoaReviewRevocationQueryVariables = Exact<{
  poaId: string | number;
  revokeDate: string;
  revokeReason: string;
}>;

export type PoaReviewRevocationQuery = {
  corePOA: { previewRevocation: { content: string } } | null;
};

export type CheckCertificatesQueryVariables = Exact<{
  certificates: Array<string> | string;
  poaId: string;
}>;

export type CheckCertificatesQuery = { corePOAUsers: { checkCertificates: string } | null };

export type GetIdPoaUserQueryVariables = Exact<{
  userId: string | number;
}>;

export type GetIdPoaUserQuery = {
  corePOAUsers: {
    getData: { id: string; userType: string; email: string | null } | null;
  } | null;
};

export type SearchPoaUsersQueryVariables = Exact<{ [key: string]: never }>;

export type SearchPoaUsersQuery = {
  corePOAUsers: {
    search: Array<{
      id: string;
      name: string;
      surname: string;
      parentalName: string;
      inn: string;
      organizationName: string;
    }>;
  } | null;
};

export type GetMeQueryVariables = Exact<{ [key: string]: never }>;

export type GetMeQuery = {
  coreEmployees: {
    me: {
      id: string;
      firstName: string | null;
      middleName: string | null;
      lastName: string | null;
      status: Core_EmployeeStatus | null;
      attributes: Array<{ name: string; value: string }>;
    };
  } | null;
};

export type StaffByIdQueryVariables = Exact<{
  id: string | number;
}>;

export type StaffByIdQuery = {
  coreEmployees: {
    get: Array<{
      id: string;
      firstName: string | null;
      middleName: string | null;
      lastName: string | null;
      status: Core_EmployeeStatus | null;
      attributes: Array<{ name: string; value: string }>;
      organization_context: Array<{
        organizationID: string;
        employeeID: string;
        role: Core_EmployeeRole;
        type: Core_EmployeeType;
        position: string;
        status: Core_OrganizationEmployeeStatus;
        powers: Array<{
          code: string;
          name: string;
          basePOAID: string;
          retrustable: boolean;
        } | null> | null;
      }> | null;
    }>;
  } | null;
};

export type StaffIncomingInvitesCountQueryVariables = Exact<{ [key: string]: never }>;

export type StaffIncomingInvitesCountQuery = {
  coreEmployeeInvitations: { count: number } | null;
};

export type StaffIncomingInvitesQueryVariables = Exact<{ [key: string]: never }>;

export type StaffIncomingInvitesQuery = {
  coreEmployeeInvitations: {
    query: {
      invites: Array<{
        id: string;
        type: Core_EmployeeInvitationType;
        status: Core_EmployeeInvitationStatus;
        createdAt: string;
        updatedAt: string;
        employee: {
          id: string;
          firstName: string | null;
          middleName: string | null;
          lastName: string | null;
          status: Core_EmployeeStatus | null;
          attributes: Array<{ name: string; value: string }>;
        } | null;
        organization: {
          id: string;
          name: string;
          status: number;
          type: number;
          countryCode: string;
          createdAt: string;
          updatedAt: string;
          attributes: Array<{ name: string; value: string }>;
        };
        inviteeEmployee: {
          id: string;
          firstName: string | null;
          middleName: string | null;
          lastName: string | null;
          status: Core_EmployeeStatus | null;
          attributes: Array<{ name: string; value: string }>;
        };
      }>;
    };
  } | null;
};

export type StaffListQueryVariables = Exact<{
  searchText?: string | null | undefined;
  roles?: Array<Core_EmployeeRole> | Core_EmployeeRole | null | undefined;
}>;

export type StaffListQuery = {
  coreEmployees: {
    query: {
      employees: Array<{
        id: string;
        firstName: string | null;
        middleName: string | null;
        lastName: string | null;
        status: Core_EmployeeStatus | null;
        attributes: Array<{ name: string; value: string }>;
      }>;
    };
  } | null;
};

export type StaffOutgoingInvitesCountQueryVariables = Exact<{ [key: string]: never }>;

export type StaffOutgoingInvitesCountQuery = {
  coreEmployeeInvitations: { count: number } | null;
};

export type StaffOutgoingInvitesQueryVariables = Exact<{ [key: string]: never }>;

export type StaffOutgoingInvitesQuery = {
  coreEmployeeInvitations: {
    query: {
      invites: Array<{
        id: string;
        type: Core_EmployeeInvitationType;
        status: Core_EmployeeInvitationStatus;
        createdAt: string;
        updatedAt: string;
        employee: {
          id: string;
          firstName: string | null;
          middleName: string | null;
          lastName: string | null;
          status: Core_EmployeeStatus | null;
          attributes: Array<{ name: string; value: string }>;
        } | null;
        organization: {
          id: string;
          name: string;
          status: number;
          type: number;
          countryCode: string;
          createdAt: string;
          updatedAt: string;
          attributes: Array<{ name: string; value: string }>;
        };
        inviteeEmployee: {
          id: string;
          firstName: string | null;
          middleName: string | null;
          lastName: string | null;
          status: Core_EmployeeStatus | null;
          attributes: Array<{ name: string; value: string }>;
        };
      }>;
    };
  } | null;
};

export type StaffPoasListQueryVariables = Exact<{
  representativeEmployeeID?: string | number | null | undefined;
}>;

export type StaffPoasListQuery = {
  corePOA: {
    query: {
      poas: Array<{
        poaDraft: {
          id: string;
          number: string;
          issueDate: string;
          expirationDate: string;
          revocationDate: string | null;
          createdAt: string;
          updatedAt: string;
          status: PoaStatus;
          content: string | null;
          retrust: Core_PoaInfoRetrustParameters;
          powerDomain: Array<{ code: string; textDescription: string; content: string } | null>;
        };
      }>;
    };
  } | null;
};

export type GetPowersListQueryVariables = Exact<{ [key: string]: never }>;

export type GetPowersListQuery = {
  coreEmployeePowers: { getPowersList: Array<{ code: string; name: string }> } | null;
};

export type GetCoreWidgetQueryVariables = Exact<{ [key: string]: never }>;

export type GetCoreWidgetQuery = {
  coreWidgets: {
    my: Array<{
      id: string;
      iconHash: string | null;
      header: string;
      fields: Array<{
        id: string;
        viewName: string;
        viewIndex: number;
        access: Array<string> | null;
        path: string;
        api: string;
      }> | null;
    }> | null;
  } | null;
};

export declare const RevokeControlCards: import('graphql').DocumentNode;
export declare const SendToCorrectControlCard: import('graphql').DocumentNode;
export declare const UpdateControlCard: import('graphql').DocumentNode;
export declare const CreateAgroDocument: import('graphql').DocumentNode;
export declare const CreateCessionDocument: import('graphql').DocumentNode;
export declare const CreateDocument: import('graphql').DocumentNode;
export declare const CreateLicenseDocument: import('graphql').DocumentNode;
export declare const CreateSupplyDocument: import('graphql').DocumentNode;
export declare const CreateOperationalRequest: import('graphql').DocumentNode;
export declare const RevokeOperationalRequest: import('graphql').DocumentNode;
export declare const SendToCorrectOperationalRequest: import('graphql').DocumentNode;
export declare const NewShipmentRegistry: import('graphql').DocumentNode;
export declare const UpdateShipmentReport: import('graphql').DocumentNode;
export declare const RevokeShipmentTasks: import('graphql').DocumentNode;
export declare const SendToCorrectShipmentTask: import('graphql').DocumentNode;
export declare const UpdateShipmentTask: import('graphql').DocumentNode;
export declare const SignDocument: import('graphql').DocumentNode;
export declare const UpdateDocument: import('graphql').DocumentNode;
export declare const CreateOrganizationDocument: import('graphql').DocumentNode;
export declare const DeleteOrganizationDocument: import('graphql').DocumentNode;
export declare const ConfirmInviteFromOrganization: import('graphql').DocumentNode;
export declare const FinishInviteOrganization: import('graphql').DocumentNode;
export declare const RejectInviteFromOrganization: import('graphql').DocumentNode;
export declare const StartInviteOrganization: import('graphql').DocumentNode;
export declare const FinishRegistrationByRepresentative: import('graphql').DocumentNode;
export declare const PrepareOrganization: import('graphql').DocumentNode;
export declare const StartRegistrationByRepresentative: import('graphql').DocumentNode;
export declare const UpdateMyOrganizations: import('graphql').DocumentNode;
export declare const CreatePaymentOptions: import('graphql').DocumentNode;
export declare const SetPaymentOptions: import('graphql').DocumentNode;
export declare const UpdatePaymentOptions: import('graphql').DocumentNode;
export declare const CreatePoaDraft: import('graphql').DocumentNode;
export declare const PoaRevoke: import('graphql').DocumentNode;
export declare const PoaSign: import('graphql').DocumentNode;
export declare const SendEmailToAuthority: import('graphql').DocumentNode;
export declare const UpdatePoaDraft: import('graphql').DocumentNode;
export declare const CreatePoaUser: import('graphql').DocumentNode;
export declare const UpdatePoaUser: import('graphql').DocumentNode;
export declare const AcceptStaffInvite: import('graphql').DocumentNode;
export declare const InviteStaff: import('graphql').DocumentNode;
export declare const RejectStaffInvite: import('graphql').DocumentNode;
export declare const GetCoreDictionariesBanks: import('graphql').DocumentNode;
export declare const GetCoreDictionariesCountries: import('graphql').DocumentNode;
export declare const GetAllControlCards: import('graphql').DocumentNode;
export declare const GetControlCardScheme: import('graphql').DocumentNode;
export declare const GetOneControlCard: import('graphql').DocumentNode;
export declare const GetCoreDocumentStatuses: import('graphql').DocumentNode;
export declare const GetCoreDocumentsList: import('graphql').DocumentNode;
export declare const GetCoreDocuments: import('graphql').DocumentNode;
export declare const GetDocumentAgroproductionScheme: import('graphql').DocumentNode;
export declare const GetDocumentCessionScheme: import('graphql').DocumentNode;
export declare const GetDocumentLicencesScheme: import('graphql').DocumentNode;
export declare const GetDocumentScheme: import('graphql').DocumentNode;
export declare const GetDocumentSupplyScheme: import('graphql').DocumentNode;
export declare const GetDocumentsTemplates: import('graphql').DocumentNode;
export declare const GetAllOperationalRequests: import('graphql').DocumentNode;
export declare const GetOneOperationalRequest: import('graphql').DocumentNode;
export declare const GetOperationalRequestFilters: import('graphql').DocumentNode;
export declare const GetOperationalRequestScheme: import('graphql').DocumentNode;
export declare const GetAllShipmentRegistries: import('graphql').DocumentNode;
export declare const GetOneShipmentRegistry: import('graphql').DocumentNode;
export declare const GetShipmentRegistryScheme: import('graphql').DocumentNode;
export declare const GetAllShipmentReports: import('graphql').DocumentNode;
export declare const GetOneShipmentReport: import('graphql').DocumentNode;
export declare const GetTemplateShipmentReports: import('graphql').DocumentNode;
export declare const GetAllShipmentTasks: import('graphql').DocumentNode;
export declare const GetOneShipmentTask: import('graphql').DocumentNode;
export declare const GetShipmentTasksScheme: import('graphql').DocumentNode;
export declare const GetContractorOrganizationDocuments: import('graphql').DocumentNode;
export declare const GetMyOrganizationDocuments: import('graphql').DocumentNode;
export declare const GetMyIncomingInvitationsCount: import('graphql').DocumentNode;
export declare const GetMyIncomingInvitations: import('graphql').DocumentNode;
export declare const GetMyOutgoingInvitationsCount: import('graphql').DocumentNode;
export declare const GetMyOutgoingInvitations: import('graphql').DocumentNode;
export declare const GetCoreOrganizationsParticipations: import('graphql').DocumentNode;
export declare const GetCoreOrganizations: import('graphql').DocumentNode;
export declare const GetMyOrganizations: import('graphql').DocumentNode;
export declare const GetOrganization: import('graphql').DocumentNode;
export declare const GetPartnerOrganization: import('graphql').DocumentNode;
export declare const GetPartnersOrganizations: import('graphql').DocumentNode;
export declare const GetMyPaymentOptions: import('graphql').DocumentNode;
export declare const GetLinkForAuthority: import('graphql').DocumentNode;
export declare const GetListRetrustPoa: import('graphql').DocumentNode;
export declare const GetPoaDraftForAuthority: import('graphql').DocumentNode;
export declare const GetPoaDraftsAndXml: import('graphql').DocumentNode;
export declare const GetPoaDraftsList: import('graphql').DocumentNode;
export declare const GetPoaSignedRevocation: import('graphql').DocumentNode;
export declare const GetPoaSignedXml: import('graphql').DocumentNode;
export declare const PoaReviewRevocation: import('graphql').DocumentNode;
export declare const CheckCertificates: import('graphql').DocumentNode;
export declare const GetIdPoaUser: import('graphql').DocumentNode;
export declare const SearchPoaUsers: import('graphql').DocumentNode;
export declare const GetMe: import('graphql').DocumentNode;
export declare const StaffById: import('graphql').DocumentNode;
export declare const StaffIncomingInvitesCount: import('graphql').DocumentNode;
export declare const StaffIncomingInvites: import('graphql').DocumentNode;
export declare const StaffList: import('graphql').DocumentNode;
export declare const StaffOutgoingInvitesCount: import('graphql').DocumentNode;
export declare const StaffOutgoingInvites: import('graphql').DocumentNode;
export declare const StaffPoasList: import('graphql').DocumentNode;
export declare const GetPowersList: import('graphql').DocumentNode;
export declare const GetCoreWidget: import('graphql').DocumentNode;
export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const RevokeControlCardsDocument = new TypedDocumentString(`
    mutation RevokeControlCards($documentIds: [String!]!) {
  app5182dd71_ControlCard {
    terminate(documentIds: $documentIds) {
      status
      message {
        ru
        en
      }
    }
  }
}
    `);
export const SendToCorrectControlCardDocument = new TypedDocumentString(`
    mutation SendToCorrectControlCard($documentId: String!) {
  app5182dd71_ControlCard {
    sendToCorrect(documentId: $documentId) {
      status
      message {
        ru
        en
      }
    }
  }
}
    `);
export const UpdateControlCardDocument = new TypedDocumentString(`
    mutation UpdateControlCard($documentId: String!, $input: app5182dd71_ControlCard_Update_Input!) {
  app5182dd71_ControlCard {
    update(documentId: $documentId, input: $input) {
      id
    }
  }
}
    `);
export const CreateAgroDocumentDocument = new TypedDocumentString(`
    mutation CreateAgroDocument($input: app36c5da51_DocumentMutationNS_createInputInput!) {
  app36c5da51_Document {
    create(input: $input) {
      id
    }
  }
}
    `);
export const CreateCessionDocumentDocument = new TypedDocumentString(`
    mutation CreateCessionDocument($input: app1d1b2841_DocumentMutationCession_createInputInput!) {
  app1d1b2841_Document {
    create(input: $input) {
      id
    }
  }
}
    `);
export const CreateDocumentDocument = new TypedDocumentString(`
    mutation CreateDocument($input: app70e9b8a9_DocumentMutationNS_createInputInput!) {
  app70e9b8a9_Document {
    create(input: $input) {
      id
    }
  }
}
    `);
export const CreateLicenseDocumentDocument = new TypedDocumentString(`
    mutation CreateLicenseDocument($input: app5705572d_DocumentMutationNS_createInputInput!) {
  app5705572d_Document {
    create(input: $input) {
      id
    }
  }
}
    `);
export const CreateSupplyDocumentDocument = new TypedDocumentString(`
    mutation CreateSupplyDocument($input: app12d801b5_DocumentMutationNPSupplyAgreement_createInputInput!) {
  app12d801b5_Document {
    create(input: $input) {
      id
    }
  }
}
    `);
export const CreateOperationalRequestDocument = new TypedDocumentString(`
    mutation CreateOperationalRequest($input: app5182dd71_OperationalRequest_Create_Input!, $documentId: String) {
  app5182dd71_OperationalRequest {
    create(input: $input, documentId: $documentId) {
      id
    }
  }
}
    `);
export const RevokeOperationalRequestDocument = new TypedDocumentString(`
    mutation RevokeOperationalRequest($documentIds: [String!]!) {
  app5182dd71_OperationalRequest {
    terminate(documentIds: $documentIds) {
      status
      message {
        ru
        en
      }
    }
  }
}
    `);
export const SendToCorrectOperationalRequestDocument = new TypedDocumentString(`
    mutation SendToCorrectOperationalRequest($documentId: String!) {
  app5182dd71_OperationalRequest {
    sendToCorrect(documentId: $documentId) {
      status
      message {
        ru
        en
      }
    }
  }
}
    `);
export const NewShipmentRegistryDocument = new TypedDocumentString(`
    mutation NewShipmentRegistry($input: app5182dd71_ShipmentReport_Create_Input!) {
  app5182dd71_ShipmentReport {
    create(input: $input) {
      status
      message {
        ru
        en
      }
    }
  }
}
    `);
export const UpdateShipmentReportDocument = new TypedDocumentString(`
    mutation UpdateShipmentReport($documentId: String!) {
  app5182dd71_ShipmentReport {
    update(documentId: $documentId) {
      status
      message {
        ru
        en
      }
    }
  }
}
    `);
export const RevokeShipmentTasksDocument = new TypedDocumentString(`
    mutation RevokeShipmentTasks($documentIds: [String!]!) {
  app5182dd71_ShipmentTask {
    terminate(documentIds: $documentIds) {
      status
      message {
        ru
        en
      }
    }
  }
}
    `);
export const SendToCorrectShipmentTaskDocument = new TypedDocumentString(`
    mutation SendToCorrectShipmentTask($documentId: String!) {
  app5182dd71_ShipmentTask {
    sendToCorrect(documentId: $documentId) {
      status
      message {
        ru
        en
      }
    }
  }
}
    `);
export const UpdateShipmentTaskDocument = new TypedDocumentString(`
    mutation UpdateShipmentTask($documentId: String!, $input: app5182dd71_ShipmentTask_Update_Input!) {
  app5182dd71_ShipmentTask {
    update(documentId: $documentId, input: $input) {
      id
    }
  }
}
    `);
export const SignDocumentDocument = new TypedDocumentString(`
    mutation SignDocument($documentId: ID!, $documentVersion: Int!, $detachedSignature: String, $signature: String) {
  coreDocuments {
    sign(
      input: {documentId: $documentId, documentVersion: $documentVersion, signature: $signature, detachedSignature: $detachedSignature}
    ) {
      result
    }
  }
}
    `);
export const UpdateDocumentDocument = new TypedDocumentString(`
    mutation UpdateDocument($input: app70e9b8a9_DocumentMutationNS_updateInputInput!) {
  app70e9b8a9_Document {
    update(input: $input) {
      id
    }
  }
}
    `);
export const CreateOrganizationDocumentDocument = new TypedDocumentString(`
    mutation CreateOrganizationDocument($file: Upload!) {
  coreOrganizationDocuments {
    create(file: $file)
  }
}
    `);
export const DeleteOrganizationDocumentDocument = new TypedDocumentString(`
    mutation DeleteOrganizationDocument($id: ID!) {
  coreOrganizationDocuments {
    delete(id: $id)
  }
}
    `);
export const ConfirmInviteFromOrganizationDocument = new TypedDocumentString(`
    mutation ConfirmInviteFromOrganization($inviteId: ID!, $partnershipAgreement: Boolean!, $signature: String, $detachedSignature: String) {
  coreOrganizationInvitations {
    confirmInvitation(
      input: {inviteId: $inviteId, partnershipAgreement: $partnershipAgreement, signature: $signature, detachedSignature: $detachedSignature}
    )
  }
}
    `);
export const FinishInviteOrganizationDocument = new TypedDocumentString(`
    mutation FinishInviteOrganization($inviteId: ID!, $signature: String, $detachedSignature: String, $sendInviteEmails: [String!]) {
  coreOrganizationInvitations {
    finishInvite(
      input: {inviteId: $inviteId, signature: $signature, detachedSignature: $detachedSignature, sendInviteEmails: $sendInviteEmails}
    ) {
      inviteId
    }
  }
}
    `);
export const RejectInviteFromOrganizationDocument = new TypedDocumentString(`
    mutation RejectInviteFromOrganization($inviteId: ID!, $rejectReason: String) {
  coreOrganizationInvitations {
    confirmInvitation(
      input: {inviteId: $inviteId, partnershipAgreement: false, rejectReason: $rejectReason}
    )
  }
}
    `);
export const StartInviteOrganizationDocument = new TypedDocumentString(`
    mutation StartInviteOrganization($partnerOrganizationId: ID!, $joinDocument: core_OrganizationMutationNS_joinDocumentInput) {
  coreOrganizationInvitations {
    startInvite(
      input: {partnerOrganizationId: $partnerOrganizationId, joinDocument: $joinDocument}
    ) {
      joinDocumentContent
      inviteId
    }
  }
}
    `);
export const FinishRegistrationByRepresentativeDocument = new TypedDocumentString(`
    mutation FinishRegistrationByRepresentative($poaId: ID!, $inviteId: ID!, $signature: String!, $detachedSignature: String) {
  coreOrganizations {
    finishRegistrationByRepresentative(
      input: {poaId: $poaId, inviteId: $inviteId, signature: $signature, detachedSignature: $detachedSignature}
    ) {
      organizationId
    }
  }
}
    `);
export const PrepareOrganizationDocument = new TypedDocumentString(`
    mutation PrepareOrganization($organizationAttributes: [core_OrganizationAttributeInput!]!) {
  coreOrganizations {
    prepare(input: {organizationAttributes: $organizationAttributes}) {
      isRegistered
      inviteId
      organization {
        id
        name
        status
        type
        countryCode
        createdAt
        updatedAt
        attributes {
          name
          value
        }
      }
    }
  }
}
    `);
export const StartRegistrationByRepresentativeDocument = new TypedDocumentString(`
    mutation StartRegistrationByRepresentative($poaId: ID!, $inviteId: ID!) {
  coreOrganizations {
    startRegistrationByRepresentative(input: {inviteId: $inviteId, poaId: $poaId}) {
      joinDocumentContent
    }
  }
}
    `);
export const UpdateMyOrganizationsDocument = new TypedDocumentString(`
    mutation UpdateMyOrganizations($input: core_OrganizationMutationNS_updateOrganizationInputInput!) {
  coreOrganizations {
    update(input: $input) {
      attributes {
        name
        value
      }
      createdAt
      updatedAt
      countryCode
      type
      status
      id
      name
    }
  }
}
    `);
export const CreatePaymentOptionsDocument = new TypedDocumentString(`
    mutation CreatePaymentOptions($input: core_OrganizationPaymentOptionsMutationNS_createInputInput!) {
  coreOrganizationPaymentOptions {
    create(input: $input) {
      id
      name
      isDefault
      accountNumber
      corrNumber
      bic
      currency
      docId
      bank {
        id
        name
        status
        type
        countryCode
        createdAt
        updatedAt
        attributes {
          name
          value
        }
      }
    }
  }
}
    `);
export const SetPaymentOptionsDocument = new TypedDocumentString(`
    mutation SetPaymentOptions($input: core_OrganizationPaymentOptionsMutationNS_setInputInput!) {
  coreOrganizationPaymentOptions {
    set(input: $input) {
      id
      name
      isDefault
      accountNumber
      corrNumber
      bic
      currency
      docId
      bank {
        id
        name
        status
        type
        countryCode
        createdAt
        updatedAt
        attributes {
          name
          value
        }
      }
    }
  }
}
    `);
export const UpdatePaymentOptionsDocument = new TypedDocumentString(`
    mutation UpdatePaymentOptions($input: core_OrganizationPaymentOptionsMutationNS_updateInputInput!, $id: ID!) {
  coreOrganizationPaymentOptions {
    update(input: $input, id: $id) {
      id
      name
      isDefault
      accountNumber
      corrNumber
      bic
      currency
      docId
      bank {
        id
        name
        status
        type
        countryCode
        createdAt
        updatedAt
        attributes {
          name
          value
        }
      }
    }
  }
}
    `);
export const CreatePoaDraftDocument = new TypedDocumentString(`
    mutation CreatePoaDraft($inviteId: ID) {
  corePOA {
    createDraft(invitationId: $inviteId)
  }
}
    `);
export const PoaRevokeDocument = new TypedDocumentString(`
    mutation PoaRevoke($id: ID!, $signature: String!, $detachedSignature: String) {
  corePOA {
    revoke(id: $id, signature: $signature, detachedSignature: $detachedSignature)
  }
}
    `);
export const PoaSignDocument = new TypedDocumentString(`
    mutation PoaSign($id: ID!, $signature: String!, $detachedSignature: String, $cert: String) {
  corePOA {
    sign(
      id: $id
      signature: $signature
      detachedSignature: $detachedSignature
      cert: $cert
    )
  }
}
    `);
export const SendEmailToAuthorityDocument = new TypedDocumentString(`
    mutation SendEmailToAuthority($email: String!, $cert: String!, $poaID: String!) {
  corePOA {
    sendPOANotificationToAuthority(email: $email, cert: $cert, poaID: $poaID)
  }
}
    `);
export const UpdatePoaDraftDocument = new TypedDocumentString(`
    mutation UpdatePoaDraft($input: core_POAMutationNS_updateDraftInputInput) {
  corePOA {
    updateDraft(input: $input)
  }
}
    `);
export const CreatePoaUserDocument = new TypedDocumentString(`
    mutation CreatePoaUser($userType: String!, $request: JSONObject!) {
  corePOAUsers {
    createRepresentative(input: {userType: $userType, request: $request})
  }
}
    `);
export const UpdatePoaUserDocument = new TypedDocumentString(`
    mutation UpdatePoaUser($userId: ID!, $userType: String!, $data: JSONObject!) {
  corePOAUsers {
    updateData(userId: $userId, userType: $userType, data: $data)
  }
}
    `);
export const AcceptStaffInviteDocument = new TypedDocumentString(`
    mutation AcceptStaffInvite($invitationId: ID!) {
  coreEmployeeInvitations {
    acceptInvitation(input: {invitationId: $invitationId, isAccepted: true})
  }
}
    `);
export const InviteStaffDocument = new TypedDocumentString(`
    mutation InviteStaff($participantData: core_EmployeeInvitationMutationNS_inviteUnregisteredEmployeeInputInput!, $role: core_EmployeeRole!, $type: core_EmployeeType!, $position: String!) {
  coreEmployeeInvitations {
    invite(
      input: {participantData: $participantData, role: $role, type: $type, position: $position}
    )
  }
}
    `);
export const RejectStaffInviteDocument = new TypedDocumentString(`
    mutation RejectStaffInvite($invitationId: ID!) {
  coreEmployeeInvitations {
    acceptInvitation(input: {invitationId: $invitationId, isAccepted: false})
  }
}
    `);
export const GetCoreDictionariesBanksDocument = new TypedDocumentString(`
    query GetCoreDictionariesBanks {
  coreOrganizations {
    queryBanks {
      organizations {
        id
        name
        status
        type
        countryCode
        createdAt
        updatedAt
      }
    }
  }
}
    `);
export const GetCoreDictionariesCountriesDocument = new TypedDocumentString(`
    query GetCoreDictionariesCountries {
  coreDictionaries {
    get(ids: "74db90ed-70e7-4a03-86ae-96969b21c9af") {
      id
      appId
      alias
      title
      description
      createdAt
      updatedAt
      enums {
        id
        title
        values {
          key
          value
        }
      }
    }
  }
}
    `);
export const GetAllControlCardsDocument = new TypedDocumentString(`
    query GetAllControlCards($statusIds: [String!], $input: String, $agreementId: String, $shippingDateBefore: String, $shippingDateAfter: String) {
  app5182dd71_ControlCard {
    getList(
      filters: {input: $input, statusIds: $statusIds, agreementId: $agreementId, shippingDateBefore: $shippingDateBefore, shippingDateAfter: $shippingDateAfter}
      pagination: {page: 1, limit: 1000}
    ) {
      data {
        id
        version
        shipmentTask {
          id
          version
          operationalRequest {
            id
            orgOwnerId
            agreementName
            number
            requestDate
            deliveryBasis
            supplyAddress
            shippingDate
            goodsType
            quantity
            statusId
            employeeOwner
            employeeReceiving
            comment
          }
          statusId
          supplierExecutor
          buyerExecutor
          createdAt
          updatedAt
        }
        statusId
        actualShipmentDate
        actualQuantity
        createdAt
        updatedAt
      }
      meta {
        page
        limit
        total
      }
    }
  }
}
    `);
export const GetControlCardSchemeDocument = new TypedDocumentString(`
    query GetControlCardScheme($documentId: String!) {
  app5182dd71_ControlCard {
    getTemplate(documentId: $documentId) {
      template {
        step
        name
        type
        required
        disabled
        isSearchable
        placeholder
        fieldTransform
        fieldType
        isVisible
        isVisibleDependency
        stepLabel
        validation
        optionsDependency
        value
        label {
          ru
          en
        }
        optionsDependentSelect {
          value
          options {
            label
            value
          }
        }
        options {
          label
          value
        }
      }
    }
  }
}
    `);
export const GetOneControlCardDocument = new TypedDocumentString(`
    query GetOneControlCard($documentId: String!) {
  app5182dd71_ControlCard {
    getOne(id: $documentId) {
      id
      version
      shipmentTask {
        id
        version
        operationalRequest {
          id
          orgOwnerId
          agreementName
          number
          requestDate
          deliveryBasis
          supplyAddress
          goodsType
          quantity
          statusId
          employeeOwner
          employeeReceiving
          comment
        }
        statusId
        supplierExecutor
        buyerExecutor
        createdAt
        updatedAt
      }
      statusId
      actualShipmentDate
      actualQuantity
      createdAt
      updatedAt
    }
  }
}
    `);
export const GetCoreDocumentStatusesDocument = new TypedDocumentString(`
    query GetCoreDocumentStatuses {
  coreDocuments {
    getStatuses {
      id
      alias
      appId {
        id
      }
    }
  }
}
    `);
export const GetCoreDocumentsListDocument = new TypedDocumentString(`
    query GetCoreDocumentsList($statuses: [String!], $searchText: String, $signatureTypes: [core_DocumentSignatureType!]) {
  coreDocuments {
    query(
      filter: {sortable: {field: "date", isOrderDesc: true}, statuses: $statuses, searchText: $searchText, signatureTypes: $signatureTypes}
    ) {
      documents {
        id
        title
        number
        typeId
        docDate
        version
        statusId
        createdAt
        updatedAt
        contractors {
          id
          name
        }
        template {
          id
        }
        orgOwner {
          id
          name
          status
          type
          countryCode
          createdAt
          updatedAt
        }
      }
    }
  }
}
    `);
export const GetCoreDocumentsDocument = new TypedDocumentString(`
    query GetCoreDocuments($documentIds: [ID!]!) {
  coreDocuments {
    get(ids: $documentIds) {
      id
      typeId
      title
      tbs
      tbd {
        type
        content
      }
      number
      docDate
      version
      statusId
      createdAt
      updatedAt
      validFrom
      validTo
      signatures {
        id
        documentID
        employeeID
        organizationID
        committed
        type
        createdAt
        updatedAt
        revisions {
          signatureID
          key
          hash
          body
        }
      }
      contractors {
        id
        name
      }
      template {
        id
      }
      orgOwner {
        id
        name
        status
        type
        countryCode
        createdAt
        updatedAt
      }
      parameters {
        name
        value
      }
    }
  }
}
    `);
export const GetDocumentAgroproductionSchemeDocument = new TypedDocumentString(`
    query GetDocumentAgroproductionScheme($documentId: String) {
  app36c5da51_Document {
    getTemplate(documentId: $documentId) {
      template {
        step
        name
        type
        required
        isSearchable
        placeholder
        fieldTransform
        fieldType
        stepLabel
        validation
        value
        label {
          ru
          en
        }
        options {
          label
          value
        }
      }
    }
  }
}
    `);
export const GetDocumentCessionSchemeDocument = new TypedDocumentString(`
    query GetDocumentCessionScheme($documentId: String) {
  app1d1b2841_Document {
    getTemplate(documentId: $documentId) {
      template {
        step
        name
        type
        value
        required
        isSearchable
        placeholder
        fieldTransform
        fieldType
        label {
          en
          ru
        }
        stepLabel
        validation
        options {
          label
          value
        }
      }
    }
  }
}
    `);
export const GetDocumentLicencesSchemeDocument = new TypedDocumentString(`
    query GetDocumentLicencesScheme($templateId: String!, $documentId: String) {
  app5705572d_Document {
    getTemplate(templateId: $templateId, documentId: $documentId) {
      template {
        step
        name
        type
        value
        required
        isSearchable
        placeholder
        fieldType
        fieldTransform
        label {
          en
          ru
        }
        stepLabel
        validation
        options {
          label
          value
        }
      }
    }
  }
}
    `);
export const GetDocumentSchemeDocument = new TypedDocumentString(`
    query GetDocumentScheme($documentId: String) {
  app70e9b8a9_Document {
    getTemplate(documentId: $documentId) {
      template {
        step
        name
        type
        value
        required
        isSearchable
        placeholder
        fieldTransform
        fieldType
        label {
          en
          ru
        }
        stepLabel
        validation
        options {
          label
          value
        }
      }
    }
  }
}
    `);
export const GetDocumentSupplySchemeDocument = new TypedDocumentString(`
    query GetDocumentSupplyScheme($documentId: String) {
  app12d801b5_Document {
    getTemplate(documentId: $documentId) {
      template {
        step
        name
        type
        value
        required
        isSearchable
        placeholder
        fieldTransform
        fieldType
        label {
          en
          ru
        }
        stepLabel
        validation
        options {
          label
          value
        }
      }
    }
  }
}
    `);
export const GetDocumentsTemplatesDocument = new TypedDocumentString(`
    query GetDocumentsTemplates {
  coreDocumentTemplates {
    getPublic {
      templates {
        id
        typeId
        title
        alias
        description
        path
        api
        createdAt
        updatedAt
        application {
          id
          traits
          alias
        }
      }
    }
  }
}
    `);
export const GetAllOperationalRequestsDocument = new TypedDocumentString(`
    query GetAllOperationalRequests($statusIds: [String!], $input: String, $agreementId: String, $shippingDateBefore: String, $shippingDateAfter: String) {
  app5182dd71_OperationalRequest {
    getList(
      filters: {input: $input, statusIds: $statusIds, agreementId: $agreementId, shippingDateBefore: $shippingDateBefore, shippingDateAfter: $shippingDateAfter}
      pagination: {limit: 1000}
    ) {
      data {
        id
        version
        statusId
        orgOwnerId
        employeeOwner
        employeeReceiving
        agreementName
        number
        requestDate
        shippingDate
        deliveryBasis
        supplyAddress
        goodsType
        quantity
        createdAt
        updatedAt
      }
      meta {
        page
        limit
        total
      }
    }
  }
}
    `);
export const GetOneOperationalRequestDocument = new TypedDocumentString(`
    query GetOneOperationalRequest($documentId: String!) {
  app5182dd71_OperationalRequest {
    getOne(id: $documentId) {
      id
      number
      agreementName
      version
      statusId
      orgOwnerId
      employeeOwner
      employeeReceiving
      requestDate
      shippingDate
      deliveryBasis
      supplyAddress
      goodsType
      quantity
      comment
      createdAt
      updatedAt
    }
  }
}
    `);
export const GetOperationalRequestFiltersDocument = new TypedDocumentString(`
    query GetOperationalRequestFilters {
  app5182dd71_OperationalRequest {
    getFilterOptions {
      agreementId {
        key
        valStr
      }
    }
  }
}
    `);
export const GetOperationalRequestSchemeDocument = new TypedDocumentString(`
    query GetOperationalRequestScheme($documentId: String) {
  app5182dd71_OperationalRequest {
    getTemplate(documentId: $documentId) {
      template {
        step
        name
        type
        required
        disabled
        isSearchable
        placeholder
        fieldTransform
        fieldType
        isVisible
        isVisibleDependency
        stepLabel
        validation
        optionsDependency
        value
        label {
          ru
          en
        }
        optionsDependentSelect {
          value
          options {
            label
            value
          }
        }
        options {
          label
          value
        }
      }
    }
  }
}
    `);
export const GetAllShipmentRegistriesDocument = new TypedDocumentString(`
    query GetAllShipmentRegistries($filters: app5182dd71_ShipmentRegistry_FiltersInput) {
  app5182dd71_ShipmentRegistry {
    getList(shipmentRegistryFilters: $filters, pagination: {page: 1, limit: 20}) {
      data {
        id
        version
        statusId
        number
        period
        buyerInn
        buyerKpp
        buyer
        document
        agreement
        total
        invoiceNumber
        invoiceDate
        invoiceTotal
        createdAt
        updatedAt
      }
      meta {
        page
        limit
        total
      }
    }
  }
}
    `);
export const GetOneShipmentRegistryDocument = new TypedDocumentString(`
    query GetOneShipmentRegistry($documentId: String!) {
  app5182dd71_ShipmentRegistry {
    getOne(id: $documentId) {
      id
      version
      statusId
      number
      period
      buyerInn
      buyerKpp
      buyer
      document
      agreement
      total
      invoiceNumber
      invoiceDate
      invoiceTotal
      createdAt
      updatedAt
    }
  }
}
    `);
export const GetShipmentRegistrySchemeDocument = new TypedDocumentString(`
    query GetShipmentRegistryScheme($documentId: String!) {
  app5182dd71_ShipmentRegistry {
    getTemplate(documentId: $documentId) {
      template {
        step
        name
        type
        required
        disabled
        isSearchable
        placeholder
        fieldTransform
        fieldType
        isVisible
        isVisibleDependency
        stepLabel
        validation
        optionsDependency
        value
        label {
          ru
          en
        }
        options {
          label
          value
        }
        optionsDependentSelect {
          value
          options {
            label
            value
          }
        }
      }
    }
  }
}
    `);
export const GetAllShipmentReportsDocument = new TypedDocumentString(`
    query GetAllShipmentReports {
  app5182dd71_ShipmentReport {
    getList(pagination: {page: 1, limit: 1000}) {
      data {
        id
        number
        document
        agreement
        period
        quantity
        statusId
        orgSupplier
        orgBuyer
      }
      meta {
        page
        limit
        total
      }
    }
  }
}
    `);
export const GetOneShipmentReportDocument = new TypedDocumentString(`
    query GetOneShipmentReport($documentId: String!) {
  app5182dd71_ShipmentReport {
    getOne(id: $documentId) {
      id
      number
      document
      agreement
      period
      quantity
      statusId
      orgSupplier
      orgBuyer
      data
    }
  }
}
    `);
export const GetTemplateShipmentReportsDocument = new TypedDocumentString(`
    query GetTemplateShipmentReports {
  app5182dd71_ShipmentReport {
    getTemplate {
      template {
        step
        name
        type
        value
        required
        disabled
        isVisibleDependency
        isSearchable
        optionsDependency
        placeholder
        fieldTransform
        fieldType
        label {
          en
          ru
        }
        stepLabel
        validation
        options {
          label
          value
        }
      }
    }
  }
}
    `);
export const GetAllShipmentTasksDocument = new TypedDocumentString(`
    query GetAllShipmentTasks($agreementId: String, $input: String, $shippingDateBefore: String, $shippingDateAfter: String, $statusIds: [String!]) {
  app5182dd71_ShipmentTask {
    getList(
      filters: {input: $input, statusIds: $statusIds, agreementId: $agreementId, shippingDateBefore: $shippingDateBefore, shippingDateAfter: $shippingDateAfter}
      pagination: {limit: 1000}
    ) {
      data {
        id
        version
        operationalRequest {
          id
          orgOwnerId
          agreementName
          number
          requestDate
          shippingDate
          deliveryBasis
          supplyAddress
          goodsType
          quantity
          statusId
          employeeOwner
          employeeReceiving
          comment
        }
        statusId
        supplierExecutor
        buyerExecutor
        createdAt
        updatedAt
      }
      meta {
        page
        limit
        total
      }
    }
  }
}
    `);
export const GetOneShipmentTaskDocument = new TypedDocumentString(`
    query GetOneShipmentTask($documentId: String!) {
  app5182dd71_ShipmentTask {
    getOne(id: $documentId) {
      id
      version
      statusId
      operationalRequest {
        id
        orgOwnerId
        agreementName
        number
        requestDate
        shippingDate
        deliveryBasis
        supplyAddress
        goodsType
        quantity
        statusId
        employeeOwner
        employeeReceiving
        comment
      }
      statusId
      supplierExecutor
      buyerExecutor
      createdAt
      updatedAt
    }
  }
}
    `);
export const GetShipmentTasksSchemeDocument = new TypedDocumentString(`
    query GetShipmentTasksScheme($documentId: String!) {
  app5182dd71_ShipmentTask {
    getTemplate(documentId: $documentId) {
      template {
        step
        name
        type
        value
        required
        disabled
        isSearchable
        placeholder
        fieldTransform
        fieldType
        label {
          en
          ru
        }
        stepLabel
        validation
        options {
          label
          value
        }
      }
    }
  }
}
    `);
export const GetContractorOrganizationDocumentsDocument = new TypedDocumentString(`
    query GetContractorOrganizationDocuments($contractorId: ID!) {
  coreOrganizationDocuments {
    contractorDocuments(contractorId: $contractorId) {
      documents {
        id
        createdAt
        updatedAt
        name
        extension
        size
      }
    }
  }
}
    `);
export const GetMyOrganizationDocumentsDocument = new TypedDocumentString(`
    query GetMyOrganizationDocuments {
  coreOrganizationDocuments {
    myDocuments {
      documents {
        id
        createdAt
        updatedAt
        name
        extension
        size
      }
    }
  }
}
    `);
export const GetMyIncomingInvitationsCountDocument = new TypedDocumentString(`
    query GetMyIncomingInvitationsCount {
  coreOrganizationInvitations {
    count(filter: {isIncoming: true, statuses: sent})
  }
}
    `);
export const GetMyIncomingInvitationsDocument = new TypedDocumentString(`
    query GetMyIncomingInvitations {
  coreOrganizationInvitations {
    query(filter: {isIncoming: true, statuses: [sent, approved, rejected]}) {
      invites {
        id
        status
        joinDocumentId
        createdAt
        updatedAt
        partyOrganization {
          id
          name
          status
          type
          countryCode
          createdAt
          updatedAt
          attributes {
            name
            value
          }
        }
        isIncoming
      }
    }
  }
}
    `);
export const GetMyOutgoingInvitationsCountDocument = new TypedDocumentString(`
    query GetMyOutgoingInvitationsCount {
  coreOrganizationInvitations {
    count(filter: {isIncoming: null})
  }
}
    `);
export const GetMyOutgoingInvitationsDocument = new TypedDocumentString(`
    query GetMyOutgoingInvitations {
  coreOrganizationInvitations {
    query(
      filter: {isIncoming: false, statuses: [initiated, sent, approved, rejected]}
    ) {
      invites {
        id
        status
        joinDocumentId
        createdAt
        updatedAt
        partyOrganization {
          id
          name
          status
          type
          countryCode
          createdAt
          updatedAt
          attributes {
            name
            value
          }
        }
        isIncoming
      }
    }
  }
}
    `);
export const GetCoreOrganizationsParticipationsDocument = new TypedDocumentString(`
    query GetCoreOrganizationsParticipations {
  coreOrganizationParticipations {
    my {
      id
      role
      application {
        alias
        widgets {
          id
          header
          fields {
            id
            viewName
            viewIndex
            access
            path
            api
          }
        }
      }
    }
  }
}
    `);
export const GetCoreOrganizationsDocument = new TypedDocumentString(`
    query GetCoreOrganizations($searchText: String) {
  coreOrganizations {
    query(filter: {searchText: $searchText}) {
      organizations {
        id
        name
        status
        type
        countryCode
        createdAt
        updatedAt
        attributes {
          value
          name
        }
      }
    }
  }
}
    `);
export const GetMyOrganizationsDocument = new TypedDocumentString(`
    query GetMyOrganizations {
  coreOrganizations {
    my {
      id
      name
      status
      type
      countryCode
      createdAt
      updatedAt
      attributes(names: null) {
        name
        value
      }
    }
  }
}
    `);
export const GetOrganizationDocument = new TypedDocumentString(`
    query GetOrganization($ids: [ID!]!) {
  coreOrganizations {
    get(ids: $ids) {
      id
      name
      status
      type
      countryCode
      createdAt
      updatedAt
      attributes {
        name
        value
      }
    }
  }
}
    `);
export const GetPartnerOrganizationDocument = new TypedDocumentString(`
    query GetPartnerOrganization($id: ID!) {
  coreOrganizations {
    getPartner(id: $id) {
      partnership_agreement_date
      organization {
        id
        name
        status
        type
        countryCode
        createdAt
        updatedAt
        attributes {
          name
          value
        }
      }
      default_payment_option {
        id
        name
        isDefault
        accountNumber
        corrNumber
        bic
        currency
        docId
        bank {
          id
          name
          status
          type
          countryCode
          createdAt
          updatedAt
        }
      }
    }
  }
}
    `);
export const GetPartnersOrganizationsDocument = new TypedDocumentString(`
    query GetPartnersOrganizations($searchText: String) {
  coreOrganizations {
    getPartners(filter: {searchText: $searchText}) {
      organizations {
        id
        name
        status
        type
        countryCode
        createdAt
        updatedAt
        attributes {
          name
          value
        }
      }
    }
  }
}
    `);
export const GetMyPaymentOptionsDocument = new TypedDocumentString(`
    query GetMyPaymentOptions {
  coreOrganizationPaymentOptions {
    my {
      id
      name
      isDefault
      accountNumber
      corrNumber
      bic
      currency
      docId
      bank {
        id
        name
        status
        type
        countryCode
        createdAt
        updatedAt
        attributes {
          name
          value
        }
      }
    }
  }
}
    `);
export const GetLinkForAuthorityDocument = new TypedDocumentString(`
    query GetLinkForAuthority($poaId: ID!, $inviteId: ID!) {
  corePOA {
    getLinkForAuthority(poaId: $poaId, inviteId: $inviteId)
  }
}
    `);
export const GetListRetrustPoaDocument = new TypedDocumentString(`
    query GetListRetrustPoa {
  corePOA {
    listRetrustPOAs {
      retrustPoaInfo {
        id
        number
        issueDate
        expirationDate
        revocationDate
        createdAt
        updatedAt
        status
        content
        retrust
        authority {
          id
          userType
          rawUserInfo
        }
        recipientOrganization {
          id
          name
          status
          type
          countryCode
          createdAt
          updatedAt
          attributes {
            name
            value
          }
        }
        representative {
          id
          userType
          rawUserInfo
        }
        powerDomain {
          code
          textDescription
          content
        }
        parentPOA {
          id
          issueDate
          expirationDate
          retrustFlag
          authorityLossFlag
          retrust
        }
      }
      rootPOAInfo {
        id
        number
        issueDate
        expirationDate
        revocationDate
        createdAt
        updatedAt
        status
        content
        retrust
        authority {
          id
          userType
          rawUserInfo
        }
        recipientOrganization {
          id
          name
          status
          type
          countryCode
          createdAt
          updatedAt
          attributes {
            name
            value
          }
        }
        representative {
          id
          userType
          rawUserInfo
        }
        powerDomain {
          code
          textDescription
          content
        }
        parentPOA {
          id
          issueDate
          expirationDate
          retrustFlag
          authorityLossFlag
          retrust
        }
        delegatedPOAs {
          id
          issueDate
          expirationDate
          retrustFlag
          authorityLossFlag
          retrust
        }
      }
    }
  }
}
    `);
export const GetPoaDraftForAuthorityDocument = new TypedDocumentString(`
    query GetPoaDraftForAuthority($cert: String!, $id: ID!) {
  corePOA {
    getDraft(cert: $cert, id: $id) {
      id
      number
      issueDate
      expirationDate
      revocationDate
      createdAt
      updatedAt
      status
      content
      retrust
      authority {
        id
        userType
        rawUserInfo
      }
      recipientOrganization {
        id
        name
        status
        type
        countryCode
        createdAt
        updatedAt
        attributes {
          name
          value
        }
      }
      representative {
        id
        userType
        rawUserInfo
      }
      powerDomain {
        code
        textDescription
        content
      }
      parentPOA {
        retrust
        authorityLossFlag
        retrustFlag
      }
    }
  }
}
    `);
export const GetPoaDraftsAndXmlDocument = new TypedDocumentString(`
    query GetPoaDraftsAndXml($id: ID!, $format: core_POAQueryNS_poaFormatEnum) {
  corePOA {
    getDraft(id: $id, format: $format) {
      id
      number
      issueDate
      expirationDate
      revocationDate
      createdAt
      updatedAt
      status
      content
      authority {
        id
        userType
        rawUserInfo
      }
      recipientOrganization {
        id
        name
        status
        type
        countryCode
        createdAt
        updatedAt
      }
      representative {
        id
        userType
        rawUserInfo
      }
      powerDomain {
        code
        textDescription
        content
      }
      content
    }
  }
}
    `);
export const GetPoaDraftsListDocument = new TypedDocumentString(`
    query GetPoaDraftsList($representativeEmployeeID: ID, $status: core_POAQueryNS_queryInputUserStatus) {
  corePOA {
    query(
      filter: {status: $status, byEmployee: false, pagination: {limit: 1000}, representativeEmployeeID: $representativeEmployeeID}
    ) {
      poas {
        poaDraft {
          id
          number
          issueDate
          status
          updatedAt
          createdAt
          expirationDate
          revocationDate
          representative {
            id
            userType
            rawUserInfo
          }
          authority {
            id
            userType
            rawUserInfo
          }
          recipientOrganization {
            id
            name
            status
            type
            countryCode
            createdAt
            updatedAt
          }
          powerDomain {
            code
            textDescription
            content
          }
        }
        authority {
          id
          userType
          rawUserInfo
        }
        representative {
          id
          userType
          rawUserInfo
        }
      }
    }
  }
}
    `);
export const GetPoaSignedRevocationDocument = new TypedDocumentString(`
    query GetPoaSignedRevocation($poaId: ID!) {
  corePOA {
    getSignedRevocation(poaId: $poaId) {
      revocation {
        poaID
        content
        filename
        createdAt
      }
    }
  }
}
    `);
export const GetPoaSignedXmlDocument = new TypedDocumentString(`
    query GetPoaSignedXml($poaId: ID!) {
  corePOA {
    getSignedById(id: $poaId) {
      name
      contents
    }
  }
}
    `);
export const PoaReviewRevocationDocument = new TypedDocumentString(`
    query PoaReviewRevocation($poaId: ID!, $revokeDate: Date!, $revokeReason: String!) {
  corePOA {
    previewRevocation(
      poaId: $poaId
      input: {revokeDate: $revokeDate, revokeReason: $revokeReason}
    ) {
      content
    }
  }
}
    `);
export const CheckCertificatesDocument = new TypedDocumentString(`
    query CheckCertificates($certificates: [String!]!, $poaId: String!) {
  corePOAUsers {
    checkCertificates(input: {certificates: $certificates, poaId: $poaId})
  }
}
    `);
export const GetIdPoaUserDocument = new TypedDocumentString(`
    query GetIdPoaUser($userId: ID!) {
  corePOAUsers {
    getData(userId: $userId) {
      id
      userType
      email
    }
  }
}
    `);
export const SearchPoaUsersDocument = new TypedDocumentString(`
    query SearchPoaUsers {
  corePOAUsers {
    search(selector: "") {
      id
      name
      surname
      parentalName
      inn
      organizationName
    }
  }
}
    `);
export const GetMeDocument = new TypedDocumentString(`
    query GetMe {
  coreEmployees {
    me {
      id
      firstName
      middleName
      lastName
      status
      attributes {
        name
        value
      }
    }
  }
}
    `);
export const StaffByIdDocument = new TypedDocumentString(`
    query StaffById($id: ID!) {
  coreEmployees {
    get(ids: [$id]) {
      id
      firstName
      middleName
      lastName
      status
      attributes {
        name
        value
      }
      organization_context {
        organizationID
        employeeID
        role
        type
        position
        status
        powers {
          code
          name
          basePOAID
          retrustable
        }
      }
    }
  }
}
    `);
export const StaffIncomingInvitesCountDocument = new TypedDocumentString(`
    query StaffIncomingInvitesCount {
  coreEmployeeInvitations {
    count(filter: {isIncoming: true, statuses: sent})
  }
}
    `);
export const StaffIncomingInvitesDocument = new TypedDocumentString(`
    query StaffIncomingInvites {
  coreEmployeeInvitations {
    query(filter: {isIncoming: true, statuses: [sent, approved, rejected]}) {
      invites {
        id
        type
        status
        createdAt
        updatedAt
        employee {
          id
          firstName
          middleName
          lastName
          status
          attributes {
            name
            value
          }
        }
        organization {
          id
          name
          status
          type
          countryCode
          createdAt
          updatedAt
          attributes {
            name
            value
          }
        }
        inviteeEmployee {
          id
          firstName
          middleName
          lastName
          status
          attributes {
            name
            value
          }
        }
      }
    }
  }
}
    `);
export const StaffListDocument = new TypedDocumentString(`
    query StaffList($searchText: String, $roles: [core_EmployeeRole!]) {
  coreEmployees {
    query(filter: {searchText: $searchText, roles: $roles}) {
      employees {
        id
        firstName
        middleName
        lastName
        status
        attributes {
          name
          value
        }
      }
    }
  }
}
    `);
export const StaffOutgoingInvitesCountDocument = new TypedDocumentString(`
    query StaffOutgoingInvitesCount {
  coreEmployeeInvitations {
    count(filter: {isIncoming: null})
  }
}
    `);
export const StaffOutgoingInvitesDocument = new TypedDocumentString(`
    query StaffOutgoingInvites {
  coreEmployeeInvitations {
    query(filter: {isIncoming: false, statuses: [sent, approved, rejected]}) {
      invites {
        id
        type
        status
        createdAt
        updatedAt
        employee {
          id
          firstName
          middleName
          lastName
          status
          attributes {
            name
            value
          }
        }
        organization {
          id
          name
          status
          type
          countryCode
          createdAt
          updatedAt
          attributes {
            name
            value
          }
        }
        inviteeEmployee {
          id
          firstName
          middleName
          lastName
          status
          attributes {
            name
            value
          }
        }
      }
    }
  }
}
    `);
export const StaffPoasListDocument = new TypedDocumentString(`
    query StaffPoasList($representativeEmployeeID: ID) {
  corePOA {
    query(
      filter: {representativeEmployeeID: $representativeEmployeeID, byEmployee: false}
    ) {
      poas {
        poaDraft {
          id
          number
          issueDate
          expirationDate
          revocationDate
          createdAt
          updatedAt
          status
          content
          retrust
          powerDomain {
            code
            textDescription
            content
          }
        }
      }
    }
  }
}
    `);
export const GetPowersListDocument = new TypedDocumentString(`
    query GetPowersList {
  coreEmployeePowers {
    getPowersList {
      code
      name
    }
  }
}
    `);
export const GetCoreWidgetDocument = new TypedDocumentString(`
    query GetCoreWidget {
  coreWidgets {
    my {
      id
      iconHash
      header
      fields {
        id
        viewName
        viewIndex
        access
        path
        api
      }
    }
  }
}
    `);

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    RevokeControlCards: build.mutation<
      RevokeControlCardsMutation,
      RevokeControlCardsMutationVariables
    >({
      query: (variables) => ({
        document: RevokeControlCardsDocument as unknown as string,
        variables,
      }),
    }),
    SendToCorrectControlCard: build.mutation<
      SendToCorrectControlCardMutation,
      SendToCorrectControlCardMutationVariables
    >({
      query: (variables) => ({
        document: SendToCorrectControlCardDocument as unknown as string,
        variables,
      }),
    }),
    UpdateControlCard: build.mutation<
      UpdateControlCardMutation,
      UpdateControlCardMutationVariables
    >({
      query: (variables) => ({
        document: UpdateControlCardDocument as unknown as string,
        variables,
      }),
    }),
    CreateAgroDocument: build.mutation<
      CreateAgroDocumentMutation,
      CreateAgroDocumentMutationVariables
    >({
      query: (variables) => ({
        document: CreateAgroDocumentDocument as unknown as string,
        variables,
      }),
    }),
    CreateCessionDocument: build.mutation<
      CreateCessionDocumentMutation,
      CreateCessionDocumentMutationVariables
    >({
      query: (variables) => ({
        document: CreateCessionDocumentDocument as unknown as string,
        variables,
      }),
    }),
    CreateDocument: build.mutation<CreateDocumentMutation, CreateDocumentMutationVariables>({
      query: (variables) => ({
        document: CreateDocumentDocument as unknown as string,
        variables,
      }),
    }),
    CreateLicenseDocument: build.mutation<
      CreateLicenseDocumentMutation,
      CreateLicenseDocumentMutationVariables
    >({
      query: (variables) => ({
        document: CreateLicenseDocumentDocument as unknown as string,
        variables,
      }),
    }),
    CreateSupplyDocument: build.mutation<
      CreateSupplyDocumentMutation,
      CreateSupplyDocumentMutationVariables
    >({
      query: (variables) => ({
        document: CreateSupplyDocumentDocument as unknown as string,
        variables,
      }),
    }),
    CreateOperationalRequest: build.mutation<
      CreateOperationalRequestMutation,
      CreateOperationalRequestMutationVariables
    >({
      query: (variables) => ({
        document: CreateOperationalRequestDocument as unknown as string,
        variables,
      }),
    }),
    RevokeOperationalRequest: build.mutation<
      RevokeOperationalRequestMutation,
      RevokeOperationalRequestMutationVariables
    >({
      query: (variables) => ({
        document: RevokeOperationalRequestDocument as unknown as string,
        variables,
      }),
    }),
    SendToCorrectOperationalRequest: build.mutation<
      SendToCorrectOperationalRequestMutation,
      SendToCorrectOperationalRequestMutationVariables
    >({
      query: (variables) => ({
        document: SendToCorrectOperationalRequestDocument as unknown as string,
        variables,
      }),
    }),
    NewShipmentRegistry: build.mutation<
      NewShipmentRegistryMutation,
      NewShipmentRegistryMutationVariables
    >({
      query: (variables) => ({
        document: NewShipmentRegistryDocument as unknown as string,
        variables,
      }),
    }),
    UpdateShipmentReport: build.mutation<
      UpdateShipmentReportMutation,
      UpdateShipmentReportMutationVariables
    >({
      query: (variables) => ({
        document: UpdateShipmentReportDocument as unknown as string,
        variables,
      }),
    }),
    RevokeShipmentTasks: build.mutation<
      RevokeShipmentTasksMutation,
      RevokeShipmentTasksMutationVariables
    >({
      query: (variables) => ({
        document: RevokeShipmentTasksDocument as unknown as string,
        variables,
      }),
    }),
    SendToCorrectShipmentTask: build.mutation<
      SendToCorrectShipmentTaskMutation,
      SendToCorrectShipmentTaskMutationVariables
    >({
      query: (variables) => ({
        document: SendToCorrectShipmentTaskDocument as unknown as string,
        variables,
      }),
    }),
    UpdateShipmentTask: build.mutation<
      UpdateShipmentTaskMutation,
      UpdateShipmentTaskMutationVariables
    >({
      query: (variables) => ({
        document: UpdateShipmentTaskDocument as unknown as string,
        variables,
      }),
    }),
    SignDocument: build.mutation<SignDocumentMutation, SignDocumentMutationVariables>({
      query: (variables) => ({
        document: SignDocumentDocument as unknown as string,
        variables,
      }),
    }),
    UpdateDocument: build.mutation<UpdateDocumentMutation, UpdateDocumentMutationVariables>({
      query: (variables) => ({
        document: UpdateDocumentDocument as unknown as string,
        variables,
      }),
    }),
    CreateOrganizationDocument: build.mutation<
      CreateOrganizationDocumentMutation,
      CreateOrganizationDocumentMutationVariables
    >({
      query: (variables) => ({
        document: CreateOrganizationDocumentDocument as unknown as string,
        variables,
      }),
    }),
    DeleteOrganizationDocument: build.mutation<
      DeleteOrganizationDocumentMutation,
      DeleteOrganizationDocumentMutationVariables
    >({
      query: (variables) => ({
        document: DeleteOrganizationDocumentDocument as unknown as string,
        variables,
      }),
    }),
    ConfirmInviteFromOrganization: build.mutation<
      ConfirmInviteFromOrganizationMutation,
      ConfirmInviteFromOrganizationMutationVariables
    >({
      query: (variables) => ({
        document: ConfirmInviteFromOrganizationDocument as unknown as string,
        variables,
      }),
    }),
    FinishInviteOrganization: build.mutation<
      FinishInviteOrganizationMutation,
      FinishInviteOrganizationMutationVariables
    >({
      query: (variables) => ({
        document: FinishInviteOrganizationDocument as unknown as string,
        variables,
      }),
    }),
    RejectInviteFromOrganization: build.mutation<
      RejectInviteFromOrganizationMutation,
      RejectInviteFromOrganizationMutationVariables
    >({
      query: (variables) => ({
        document: RejectInviteFromOrganizationDocument as unknown as string,
        variables,
      }),
    }),
    StartInviteOrganization: build.mutation<
      StartInviteOrganizationMutation,
      StartInviteOrganizationMutationVariables
    >({
      query: (variables) => ({
        document: StartInviteOrganizationDocument as unknown as string,
        variables,
      }),
    }),
    FinishRegistrationByRepresentative: build.mutation<
      FinishRegistrationByRepresentativeMutation,
      FinishRegistrationByRepresentativeMutationVariables
    >({
      query: (variables) => ({
        document: FinishRegistrationByRepresentativeDocument as unknown as string,
        variables,
      }),
    }),
    PrepareOrganization: build.mutation<
      PrepareOrganizationMutation,
      PrepareOrganizationMutationVariables
    >({
      query: (variables) => ({
        document: PrepareOrganizationDocument as unknown as string,
        variables,
      }),
    }),
    StartRegistrationByRepresentative: build.mutation<
      StartRegistrationByRepresentativeMutation,
      StartRegistrationByRepresentativeMutationVariables
    >({
      query: (variables) => ({
        document: StartRegistrationByRepresentativeDocument as unknown as string,
        variables,
      }),
    }),
    UpdateMyOrganizations: build.mutation<
      UpdateMyOrganizationsMutation,
      UpdateMyOrganizationsMutationVariables
    >({
      query: (variables) => ({
        document: UpdateMyOrganizationsDocument as unknown as string,
        variables,
      }),
    }),
    CreatePaymentOptions: build.mutation<
      CreatePaymentOptionsMutation,
      CreatePaymentOptionsMutationVariables
    >({
      query: (variables) => ({
        document: CreatePaymentOptionsDocument as unknown as string,
        variables,
      }),
    }),
    SetPaymentOptions: build.mutation<
      SetPaymentOptionsMutation,
      SetPaymentOptionsMutationVariables
    >({
      query: (variables) => ({
        document: SetPaymentOptionsDocument as unknown as string,
        variables,
      }),
    }),
    UpdatePaymentOptions: build.mutation<
      UpdatePaymentOptionsMutation,
      UpdatePaymentOptionsMutationVariables
    >({
      query: (variables) => ({
        document: UpdatePaymentOptionsDocument as unknown as string,
        variables,
      }),
    }),
    CreatePoaDraft: build.mutation<
      CreatePoaDraftMutation,
      CreatePoaDraftMutationVariables | void
    >({
      query: (variables) => ({
        document: CreatePoaDraftDocument as unknown as string,
        variables,
      }),
    }),
    PoaRevoke: build.mutation<PoaRevokeMutation, PoaRevokeMutationVariables>({
      query: (variables) => ({ document: PoaRevokeDocument as unknown as string, variables }),
    }),
    PoaSign: build.mutation<PoaSignMutation, PoaSignMutationVariables>({
      query: (variables) => ({ document: PoaSignDocument as unknown as string, variables }),
    }),
    SendEmailToAuthority: build.mutation<
      SendEmailToAuthorityMutation,
      SendEmailToAuthorityMutationVariables
    >({
      query: (variables) => ({
        document: SendEmailToAuthorityDocument as unknown as string,
        variables,
      }),
    }),
    UpdatePoaDraft: build.mutation<
      UpdatePoaDraftMutation,
      UpdatePoaDraftMutationVariables | void
    >({
      query: (variables) => ({
        document: UpdatePoaDraftDocument as unknown as string,
        variables,
      }),
    }),
    CreatePoaUser: build.mutation<CreatePoaUserMutation, CreatePoaUserMutationVariables>({
      query: (variables) => ({
        document: CreatePoaUserDocument as unknown as string,
        variables,
      }),
    }),
    UpdatePoaUser: build.mutation<UpdatePoaUserMutation, UpdatePoaUserMutationVariables>({
      query: (variables) => ({
        document: UpdatePoaUserDocument as unknown as string,
        variables,
      }),
    }),
    AcceptStaffInvite: build.mutation<
      AcceptStaffInviteMutation,
      AcceptStaffInviteMutationVariables
    >({
      query: (variables) => ({
        document: AcceptStaffInviteDocument as unknown as string,
        variables,
      }),
    }),
    InviteStaff: build.mutation<InviteStaffMutation, InviteStaffMutationVariables>({
      query: (variables) => ({ document: InviteStaffDocument as unknown as string, variables }),
    }),
    RejectStaffInvite: build.mutation<
      RejectStaffInviteMutation,
      RejectStaffInviteMutationVariables
    >({
      query: (variables) => ({
        document: RejectStaffInviteDocument as unknown as string,
        variables,
      }),
    }),
    GetCoreDictionariesBanks: build.query<
      GetCoreDictionariesBanksQuery,
      GetCoreDictionariesBanksQueryVariables | void
    >({
      query: (variables) => ({
        document: GetCoreDictionariesBanksDocument as unknown as string,
        variables,
      }),
    }),
    GetCoreDictionariesCountries: build.query<
      GetCoreDictionariesCountriesQuery,
      GetCoreDictionariesCountriesQueryVariables | void
    >({
      query: (variables) => ({
        document: GetCoreDictionariesCountriesDocument as unknown as string,
        variables,
      }),
    }),
    GetAllControlCards: build.query<
      GetAllControlCardsQuery,
      GetAllControlCardsQueryVariables | void
    >({
      query: (variables) => ({
        document: GetAllControlCardsDocument as unknown as string,
        variables,
      }),
    }),
    GetControlCardScheme: build.query<
      GetControlCardSchemeQuery,
      GetControlCardSchemeQueryVariables
    >({
      query: (variables) => ({
        document: GetControlCardSchemeDocument as unknown as string,
        variables,
      }),
    }),
    GetOneControlCard: build.query<GetOneControlCardQuery, GetOneControlCardQueryVariables>({
      query: (variables) => ({
        document: GetOneControlCardDocument as unknown as string,
        variables,
      }),
    }),
    GetCoreDocumentStatuses: build.query<
      GetCoreDocumentStatusesQuery,
      GetCoreDocumentStatusesQueryVariables | void
    >({
      query: (variables) => ({
        document: GetCoreDocumentStatusesDocument as unknown as string,
        variables,
      }),
    }),
    GetCoreDocumentsList: build.query<
      GetCoreDocumentsListQuery,
      GetCoreDocumentsListQueryVariables | void
    >({
      query: (variables) => ({
        document: GetCoreDocumentsListDocument as unknown as string,
        variables,
      }),
    }),
    GetCoreDocuments: build.query<GetCoreDocumentsQuery, GetCoreDocumentsQueryVariables>({
      query: (variables) => ({
        document: GetCoreDocumentsDocument as unknown as string,
        variables,
      }),
    }),
    GetDocumentAgroproductionScheme: build.query<
      GetDocumentAgroproductionSchemeQuery,
      GetDocumentAgroproductionSchemeQueryVariables | void
    >({
      query: (variables) => ({
        document: GetDocumentAgroproductionSchemeDocument as unknown as string,
        variables,
      }),
    }),
    GetDocumentCessionScheme: build.query<
      GetDocumentCessionSchemeQuery,
      GetDocumentCessionSchemeQueryVariables | void
    >({
      query: (variables) => ({
        document: GetDocumentCessionSchemeDocument as unknown as string,
        variables,
      }),
    }),
    GetDocumentLicencesScheme: build.query<
      GetDocumentLicencesSchemeQuery,
      GetDocumentLicencesSchemeQueryVariables
    >({
      query: (variables) => ({
        document: GetDocumentLicencesSchemeDocument as unknown as string,
        variables,
      }),
    }),
    GetDocumentScheme: build.query<
      GetDocumentSchemeQuery,
      GetDocumentSchemeQueryVariables | void
    >({
      query: (variables) => ({
        document: GetDocumentSchemeDocument as unknown as string,
        variables,
      }),
    }),
    GetDocumentSupplyScheme: build.query<
      GetDocumentSupplySchemeQuery,
      GetDocumentSupplySchemeQueryVariables | void
    >({
      query: (variables) => ({
        document: GetDocumentSupplySchemeDocument as unknown as string,
        variables,
      }),
    }),
    GetDocumentsTemplates: build.query<
      GetDocumentsTemplatesQuery,
      GetDocumentsTemplatesQueryVariables | void
    >({
      query: (variables) => ({
        document: GetDocumentsTemplatesDocument as unknown as string,
        variables,
      }),
    }),
    GetAllOperationalRequests: build.query<
      GetAllOperationalRequestsQuery,
      GetAllOperationalRequestsQueryVariables | void
    >({
      query: (variables) => ({
        document: GetAllOperationalRequestsDocument as unknown as string,
        variables,
      }),
    }),
    GetOneOperationalRequest: build.query<
      GetOneOperationalRequestQuery,
      GetOneOperationalRequestQueryVariables
    >({
      query: (variables) => ({
        document: GetOneOperationalRequestDocument as unknown as string,
        variables,
      }),
    }),
    GetOperationalRequestFilters: build.query<
      GetOperationalRequestFiltersQuery,
      GetOperationalRequestFiltersQueryVariables | void
    >({
      query: (variables) => ({
        document: GetOperationalRequestFiltersDocument as unknown as string,
        variables,
      }),
    }),
    GetOperationalRequestScheme: build.query<
      GetOperationalRequestSchemeQuery,
      GetOperationalRequestSchemeQueryVariables | void
    >({
      query: (variables) => ({
        document: GetOperationalRequestSchemeDocument as unknown as string,
        variables,
      }),
    }),
    GetAllShipmentRegistries: build.query<
      GetAllShipmentRegistriesQuery,
      GetAllShipmentRegistriesQueryVariables | void
    >({
      query: (variables) => ({
        document: GetAllShipmentRegistriesDocument as unknown as string,
        variables,
      }),
    }),
    GetOneShipmentRegistry: build.query<
      GetOneShipmentRegistryQuery,
      GetOneShipmentRegistryQueryVariables
    >({
      query: (variables) => ({
        document: GetOneShipmentRegistryDocument as unknown as string,
        variables,
      }),
    }),
    GetShipmentRegistryScheme: build.query<
      GetShipmentRegistrySchemeQuery,
      GetShipmentRegistrySchemeQueryVariables
    >({
      query: (variables) => ({
        document: GetShipmentRegistrySchemeDocument as unknown as string,
        variables,
      }),
    }),
    GetAllShipmentReports: build.query<
      GetAllShipmentReportsQuery,
      GetAllShipmentReportsQueryVariables | void
    >({
      query: (variables) => ({
        document: GetAllShipmentReportsDocument as unknown as string,
        variables,
      }),
    }),
    GetOneShipmentReport: build.query<
      GetOneShipmentReportQuery,
      GetOneShipmentReportQueryVariables
    >({
      query: (variables) => ({
        document: GetOneShipmentReportDocument as unknown as string,
        variables,
      }),
    }),
    GetTemplateShipmentReports: build.query<
      GetTemplateShipmentReportsQuery,
      GetTemplateShipmentReportsQueryVariables | void
    >({
      query: (variables) => ({
        document: GetTemplateShipmentReportsDocument as unknown as string,
        variables,
      }),
    }),
    GetAllShipmentTasks: build.query<
      GetAllShipmentTasksQuery,
      GetAllShipmentTasksQueryVariables | void
    >({
      query: (variables) => ({
        document: GetAllShipmentTasksDocument as unknown as string,
        variables,
      }),
    }),
    GetOneShipmentTask: build.query<GetOneShipmentTaskQuery, GetOneShipmentTaskQueryVariables>({
      query: (variables) => ({
        document: GetOneShipmentTaskDocument as unknown as string,
        variables,
      }),
    }),
    GetShipmentTasksScheme: build.query<
      GetShipmentTasksSchemeQuery,
      GetShipmentTasksSchemeQueryVariables
    >({
      query: (variables) => ({
        document: GetShipmentTasksSchemeDocument as unknown as string,
        variables,
      }),
    }),
    GetContractorOrganizationDocuments: build.query<
      GetContractorOrganizationDocumentsQuery,
      GetContractorOrganizationDocumentsQueryVariables
    >({
      query: (variables) => ({
        document: GetContractorOrganizationDocumentsDocument as unknown as string,
        variables,
      }),
    }),
    GetMyOrganizationDocuments: build.query<
      GetMyOrganizationDocumentsQuery,
      GetMyOrganizationDocumentsQueryVariables | void
    >({
      query: (variables) => ({
        document: GetMyOrganizationDocumentsDocument as unknown as string,
        variables,
      }),
    }),
    GetMyIncomingInvitationsCount: build.query<
      GetMyIncomingInvitationsCountQuery,
      GetMyIncomingInvitationsCountQueryVariables | void
    >({
      query: (variables) => ({
        document: GetMyIncomingInvitationsCountDocument as unknown as string,
        variables,
      }),
    }),
    GetMyIncomingInvitations: build.query<
      GetMyIncomingInvitationsQuery,
      GetMyIncomingInvitationsQueryVariables | void
    >({
      query: (variables) => ({
        document: GetMyIncomingInvitationsDocument as unknown as string,
        variables,
      }),
    }),
    GetMyOutgoingInvitationsCount: build.query<
      GetMyOutgoingInvitationsCountQuery,
      GetMyOutgoingInvitationsCountQueryVariables | void
    >({
      query: (variables) => ({
        document: GetMyOutgoingInvitationsCountDocument as unknown as string,
        variables,
      }),
    }),
    GetMyOutgoingInvitations: build.query<
      GetMyOutgoingInvitationsQuery,
      GetMyOutgoingInvitationsQueryVariables | void
    >({
      query: (variables) => ({
        document: GetMyOutgoingInvitationsDocument as unknown as string,
        variables,
      }),
    }),
    GetCoreOrganizationsParticipations: build.query<
      GetCoreOrganizationsParticipationsQuery,
      GetCoreOrganizationsParticipationsQueryVariables | void
    >({
      query: (variables) => ({
        document: GetCoreOrganizationsParticipationsDocument as unknown as string,
        variables,
      }),
    }),
    GetCoreOrganizations: build.query<
      GetCoreOrganizationsQuery,
      GetCoreOrganizationsQueryVariables | void
    >({
      query: (variables) => ({
        document: GetCoreOrganizationsDocument as unknown as string,
        variables,
      }),
    }),
    GetMyOrganizations: build.query<
      GetMyOrganizationsQuery,
      GetMyOrganizationsQueryVariables | void
    >({
      query: (variables) => ({
        document: GetMyOrganizationsDocument as unknown as string,
        variables,
      }),
    }),
    GetOrganization: build.query<GetOrganizationQuery, GetOrganizationQueryVariables>({
      query: (variables) => ({
        document: GetOrganizationDocument as unknown as string,
        variables,
      }),
    }),
    GetPartnerOrganization: build.query<
      GetPartnerOrganizationQuery,
      GetPartnerOrganizationQueryVariables
    >({
      query: (variables) => ({
        document: GetPartnerOrganizationDocument as unknown as string,
        variables,
      }),
    }),
    GetPartnersOrganizations: build.query<
      GetPartnersOrganizationsQuery,
      GetPartnersOrganizationsQueryVariables | void
    >({
      query: (variables) => ({
        document: GetPartnersOrganizationsDocument as unknown as string,
        variables,
      }),
    }),
    GetMyPaymentOptions: build.query<
      GetMyPaymentOptionsQuery,
      GetMyPaymentOptionsQueryVariables | void
    >({
      query: (variables) => ({
        document: GetMyPaymentOptionsDocument as unknown as string,
        variables,
      }),
    }),
    GetLinkForAuthority: build.query<
      GetLinkForAuthorityQuery,
      GetLinkForAuthorityQueryVariables
    >({
      query: (variables) => ({
        document: GetLinkForAuthorityDocument as unknown as string,
        variables,
      }),
    }),
    GetListRetrustPoa: build.query<
      GetListRetrustPoaQuery,
      GetListRetrustPoaQueryVariables | void
    >({
      query: (variables) => ({
        document: GetListRetrustPoaDocument as unknown as string,
        variables,
      }),
    }),
    GetPoaDraftForAuthority: build.query<
      GetPoaDraftForAuthorityQuery,
      GetPoaDraftForAuthorityQueryVariables
    >({
      query: (variables) => ({
        document: GetPoaDraftForAuthorityDocument as unknown as string,
        variables,
      }),
    }),
    GetPoaDraftsAndXml: build.query<GetPoaDraftsAndXmlQuery, GetPoaDraftsAndXmlQueryVariables>({
      query: (variables) => ({
        document: GetPoaDraftsAndXmlDocument as unknown as string,
        variables,
      }),
    }),
    GetPoaDraftsList: build.query<GetPoaDraftsListQuery, GetPoaDraftsListQueryVariables | void>(
      {
        query: (variables) => ({
          document: GetPoaDraftsListDocument as unknown as string,
          variables,
        }),
      },
    ),
    GetPoaSignedRevocation: build.query<
      GetPoaSignedRevocationQuery,
      GetPoaSignedRevocationQueryVariables
    >({
      query: (variables) => ({
        document: GetPoaSignedRevocationDocument as unknown as string,
        variables,
      }),
    }),
    GetPoaSignedXml: build.query<GetPoaSignedXmlQuery, GetPoaSignedXmlQueryVariables>({
      query: (variables) => ({
        document: GetPoaSignedXmlDocument as unknown as string,
        variables,
      }),
    }),
    PoaReviewRevocation: build.query<
      PoaReviewRevocationQuery,
      PoaReviewRevocationQueryVariables
    >({
      query: (variables) => ({
        document: PoaReviewRevocationDocument as unknown as string,
        variables,
      }),
    }),
    CheckCertificates: build.query<CheckCertificatesQuery, CheckCertificatesQueryVariables>({
      query: (variables) => ({
        document: CheckCertificatesDocument as unknown as string,
        variables,
      }),
    }),
    GetIdPoaUser: build.query<GetIdPoaUserQuery, GetIdPoaUserQueryVariables>({
      query: (variables) => ({
        document: GetIdPoaUserDocument as unknown as string,
        variables,
      }),
    }),
    SearchPoaUsers: build.query<SearchPoaUsersQuery, SearchPoaUsersQueryVariables | void>({
      query: (variables) => ({
        document: SearchPoaUsersDocument as unknown as string,
        variables,
      }),
    }),
    GetMe: build.query<GetMeQuery, GetMeQueryVariables | void>({
      query: (variables) => ({ document: GetMeDocument as unknown as string, variables }),
    }),
    StaffById: build.query<StaffByIdQuery, StaffByIdQueryVariables>({
      query: (variables) => ({ document: StaffByIdDocument as unknown as string, variables }),
    }),
    StaffIncomingInvitesCount: build.query<
      StaffIncomingInvitesCountQuery,
      StaffIncomingInvitesCountQueryVariables | void
    >({
      query: (variables) => ({
        document: StaffIncomingInvitesCountDocument as unknown as string,
        variables,
      }),
    }),
    StaffIncomingInvites: build.query<
      StaffIncomingInvitesQuery,
      StaffIncomingInvitesQueryVariables | void
    >({
      query: (variables) => ({
        document: StaffIncomingInvitesDocument as unknown as string,
        variables,
      }),
    }),
    StaffList: build.query<StaffListQuery, StaffListQueryVariables | void>({
      query: (variables) => ({ document: StaffListDocument as unknown as string, variables }),
    }),
    StaffOutgoingInvitesCount: build.query<
      StaffOutgoingInvitesCountQuery,
      StaffOutgoingInvitesCountQueryVariables | void
    >({
      query: (variables) => ({
        document: StaffOutgoingInvitesCountDocument as unknown as string,
        variables,
      }),
    }),
    StaffOutgoingInvites: build.query<
      StaffOutgoingInvitesQuery,
      StaffOutgoingInvitesQueryVariables | void
    >({
      query: (variables) => ({
        document: StaffOutgoingInvitesDocument as unknown as string,
        variables,
      }),
    }),
    StaffPoasList: build.query<StaffPoasListQuery, StaffPoasListQueryVariables | void>({
      query: (variables) => ({
        document: StaffPoasListDocument as unknown as string,
        variables,
      }),
    }),
    GetPowersList: build.query<GetPowersListQuery, GetPowersListQueryVariables | void>({
      query: (variables) => ({
        document: GetPowersListDocument as unknown as string,
        variables,
      }),
    }),
    GetCoreWidget: build.query<GetCoreWidgetQuery, GetCoreWidgetQueryVariables | void>({
      query: (variables) => ({
        document: GetCoreWidgetDocument as unknown as string,
        variables,
      }),
    }),
  }),
});

export { injectedRtkApi as api };
export const {
  useRevokeControlCardsMutation,
  useSendToCorrectControlCardMutation,
  useUpdateControlCardMutation,
  useCreateAgroDocumentMutation,
  useCreateCessionDocumentMutation,
  useCreateDocumentMutation,
  useCreateLicenseDocumentMutation,
  useCreateSupplyDocumentMutation,
  useCreateOperationalRequestMutation,
  useRevokeOperationalRequestMutation,
  useSendToCorrectOperationalRequestMutation,
  useNewShipmentRegistryMutation,
  useUpdateShipmentReportMutation,
  useRevokeShipmentTasksMutation,
  useSendToCorrectShipmentTaskMutation,
  useUpdateShipmentTaskMutation,
  useSignDocumentMutation,
  useUpdateDocumentMutation,
  useCreateOrganizationDocumentMutation,
  useDeleteOrganizationDocumentMutation,
  useConfirmInviteFromOrganizationMutation,
  useFinishInviteOrganizationMutation,
  useRejectInviteFromOrganizationMutation,
  useStartInviteOrganizationMutation,
  useFinishRegistrationByRepresentativeMutation,
  usePrepareOrganizationMutation,
  useStartRegistrationByRepresentativeMutation,
  useUpdateMyOrganizationsMutation,
  useCreatePaymentOptionsMutation,
  useSetPaymentOptionsMutation,
  useUpdatePaymentOptionsMutation,
  useCreatePoaDraftMutation,
  usePoaRevokeMutation,
  usePoaSignMutation,
  useSendEmailToAuthorityMutation,
  useUpdatePoaDraftMutation,
  useCreatePoaUserMutation,
  useUpdatePoaUserMutation,
  useAcceptStaffInviteMutation,
  useInviteStaffMutation,
  useRejectStaffInviteMutation,
  useGetCoreDictionariesBanksQuery,
  useLazyGetCoreDictionariesBanksQuery,
  useGetCoreDictionariesCountriesQuery,
  useLazyGetCoreDictionariesCountriesQuery,
  useGetAllControlCardsQuery,
  useLazyGetAllControlCardsQuery,
  useGetControlCardSchemeQuery,
  useLazyGetControlCardSchemeQuery,
  useGetOneControlCardQuery,
  useLazyGetOneControlCardQuery,
  useGetCoreDocumentStatusesQuery,
  useLazyGetCoreDocumentStatusesQuery,
  useGetCoreDocumentsListQuery,
  useLazyGetCoreDocumentsListQuery,
  useGetCoreDocumentsQuery,
  useLazyGetCoreDocumentsQuery,
  useGetDocumentAgroproductionSchemeQuery,
  useLazyGetDocumentAgroproductionSchemeQuery,
  useGetDocumentCessionSchemeQuery,
  useLazyGetDocumentCessionSchemeQuery,
  useGetDocumentLicencesSchemeQuery,
  useLazyGetDocumentLicencesSchemeQuery,
  useGetDocumentSchemeQuery,
  useLazyGetDocumentSchemeQuery,
  useGetDocumentSupplySchemeQuery,
  useLazyGetDocumentSupplySchemeQuery,
  useGetDocumentsTemplatesQuery,
  useLazyGetDocumentsTemplatesQuery,
  useGetAllOperationalRequestsQuery,
  useLazyGetAllOperationalRequestsQuery,
  useGetOneOperationalRequestQuery,
  useLazyGetOneOperationalRequestQuery,
  useGetOperationalRequestFiltersQuery,
  useLazyGetOperationalRequestFiltersQuery,
  useGetOperationalRequestSchemeQuery,
  useLazyGetOperationalRequestSchemeQuery,
  useGetAllShipmentRegistriesQuery,
  useLazyGetAllShipmentRegistriesQuery,
  useGetOneShipmentRegistryQuery,
  useLazyGetOneShipmentRegistryQuery,
  useGetShipmentRegistrySchemeQuery,
  useLazyGetShipmentRegistrySchemeQuery,
  useGetAllShipmentReportsQuery,
  useLazyGetAllShipmentReportsQuery,
  useGetOneShipmentReportQuery,
  useLazyGetOneShipmentReportQuery,
  useGetTemplateShipmentReportsQuery,
  useLazyGetTemplateShipmentReportsQuery,
  useGetAllShipmentTasksQuery,
  useLazyGetAllShipmentTasksQuery,
  useGetOneShipmentTaskQuery,
  useLazyGetOneShipmentTaskQuery,
  useGetShipmentTasksSchemeQuery,
  useLazyGetShipmentTasksSchemeQuery,
  useGetContractorOrganizationDocumentsQuery,
  useLazyGetContractorOrganizationDocumentsQuery,
  useGetMyOrganizationDocumentsQuery,
  useLazyGetMyOrganizationDocumentsQuery,
  useGetMyIncomingInvitationsCountQuery,
  useLazyGetMyIncomingInvitationsCountQuery,
  useGetMyIncomingInvitationsQuery,
  useLazyGetMyIncomingInvitationsQuery,
  useGetMyOutgoingInvitationsCountQuery,
  useLazyGetMyOutgoingInvitationsCountQuery,
  useGetMyOutgoingInvitationsQuery,
  useLazyGetMyOutgoingInvitationsQuery,
  useGetCoreOrganizationsParticipationsQuery,
  useLazyGetCoreOrganizationsParticipationsQuery,
  useGetCoreOrganizationsQuery,
  useLazyGetCoreOrganizationsQuery,
  useGetMyOrganizationsQuery,
  useLazyGetMyOrganizationsQuery,
  useGetOrganizationQuery,
  useLazyGetOrganizationQuery,
  useGetPartnerOrganizationQuery,
  useLazyGetPartnerOrganizationQuery,
  useGetPartnersOrganizationsQuery,
  useLazyGetPartnersOrganizationsQuery,
  useGetMyPaymentOptionsQuery,
  useLazyGetMyPaymentOptionsQuery,
  useGetLinkForAuthorityQuery,
  useLazyGetLinkForAuthorityQuery,
  useGetListRetrustPoaQuery,
  useLazyGetListRetrustPoaQuery,
  useGetPoaDraftForAuthorityQuery,
  useLazyGetPoaDraftForAuthorityQuery,
  useGetPoaDraftsAndXmlQuery,
  useLazyGetPoaDraftsAndXmlQuery,
  useGetPoaDraftsListQuery,
  useLazyGetPoaDraftsListQuery,
  useGetPoaSignedRevocationQuery,
  useLazyGetPoaSignedRevocationQuery,
  useGetPoaSignedXmlQuery,
  useLazyGetPoaSignedXmlQuery,
  usePoaReviewRevocationQuery,
  useLazyPoaReviewRevocationQuery,
  useCheckCertificatesQuery,
  useLazyCheckCertificatesQuery,
  useGetIdPoaUserQuery,
  useLazyGetIdPoaUserQuery,
  useSearchPoaUsersQuery,
  useLazySearchPoaUsersQuery,
  useGetMeQuery,
  useLazyGetMeQuery,
  useStaffByIdQuery,
  useLazyStaffByIdQuery,
  useStaffIncomingInvitesCountQuery,
  useLazyStaffIncomingInvitesCountQuery,
  useStaffIncomingInvitesQuery,
  useLazyStaffIncomingInvitesQuery,
  useStaffListQuery,
  useLazyStaffListQuery,
  useStaffOutgoingInvitesCountQuery,
  useLazyStaffOutgoingInvitesCountQuery,
  useStaffOutgoingInvitesQuery,
  useLazyStaffOutgoingInvitesQuery,
  useStaffPoasListQuery,
  useLazyStaffPoasListQuery,
  useGetPowersListQuery,
  useLazyGetPowersListQuery,
  useGetCoreWidgetQuery,
  useLazyGetCoreWidgetQuery,
} = injectedRtkApi;
